export default `:host([label-position=inline-start]) .ids-input,
:host([label-position=inline-start]) .ids-textarea {
  display: flex;
  align-items: var(--ids-label-align-y, center);
}
:host([label-position=inline-start]) .ids-input label,
:host([label-position=inline-start]) .ids-textarea label {
  width: var(--ids-label-width);
  padding-block: var(--ids-label-padding-block);
  padding-inline-end: 0;
  box-sizing: border-box;
  flex-shrink: 0;
}
:host([label-position=inline-start]) .ids-input .validation-message,
:host([label-position=inline-start]) .ids-textarea .validation-message {
  width: 100%;
  margin-block-start: var(--ids-space-2xs);
}
@media (max-width: 927px) {
  :host([label-position=inline-start]) .ids-input .validation-message,
  :host([label-position=inline-start]) .ids-textarea .validation-message {
    margin-inline-start: 0;
  }
}
@media (width > 320px) {
  :host([label-position=inline-start]) .ids-input .ids-label-text,
  :host([label-position=inline-start]) .ids-textarea .ids-label-text {
    margin-inline-end: 0;
  }
}
@container (width > \$breakpoint-xs) {
  :host([label-position=inline-start]) .ids-input .ids-label-text,
  :host([label-position=inline-start]) .ids-textarea .ids-label-text {
    margin-inline-end: 0;
  }
}
@media (min-width: 320px) {
  :host([label-position=inline-start]) .ids-input,
  :host([label-position=inline-start]) .ids-textarea {
    flex-wrap: wrap;
    gap: 8px;
  }
  :host([label-position=inline-start]) .ids-input label,
  :host([label-position=inline-start]) .ids-textarea label {
    flex: 0 0 auto;
    margin-bottom: unset;
    order: 1;
  }
  :host([label-position=inline-start]) .ids-input .field-container,
  :host([label-position=inline-start]) .ids-textarea .field-container {
    order: 2;
  }
  :host([label-position=inline-start]) .ids-input .textarea-field-group,
  :host([label-position=inline-start]) .ids-textarea .textarea-field-group {
    order: 2;
    flex: 1 1 auto;
    min-width: 0;
  }
  :host([label-position=inline-start]) .ids-input .validation-message,
  :host([label-position=inline-start]) .ids-textarea .validation-message {
    flex: 1 1 100%;
    min-width: 100%;
    order: 3;
    margin-block-start: calc(0px - var(--ids-space-2xs));
  }
  :host([label-position=inline-start]) .ids-input.wrapped .validation-message,
  :host([label-position=inline-start]) .ids-textarea.wrapped .validation-message {
    margin-block-start: calc(0px - var(--ids-space-2xs));
    margin-inline-start: calc(var(--ids-label-width) + 6px);
  }
}
:host([label-position=inline-start]) .ids-checkbox {
  margin-top: var(--ids-space-00);
}
@media (min-width: 320px) {
  :host([label-position=inline-start]) .ids-checkbox {
    display: flex;
    flex-wrap: wrap;
    align-items: var(--ids-label-align-y, center);
  }
  :host([label-position=inline-start]) .ids-checkbox label {
    display: flex;
    align-items: center;
    width: 100%;
    padding-block: var(--ids-label-padding-block);
    box-sizing: border-box;
    gap: var(--ids-space-xs);
  }
  :host([label-position=inline-start]) .ids-checkbox .label-checkbox {
    width: var(--ids-label-width);
    flex-shrink: 0;
  }
  :host([label-position=inline-start]) .ids-checkbox .checkbox-wrapper {
    position: relative;
    display: inline-flex;
  }
  :host([label-position=inline-start]) .ids-checkbox .field-container {
    flex: 1;
  }
  :host([label-position=inline-start]) .ids-checkbox .validation-message {
    width: 100%;
    margin-inline-start: calc(var(--ids-label-width) + var(--ids-space-xs));
    margin-block-start: var(--ids-space-2xs);
  }
}
@container (min-width: 320px) {
  :host([label-position=inline-start]) .ids-checkbox {
    display: flex;
    flex-wrap: wrap;
    align-items: var(--ids-label-align-y, center);
  }
  :host([label-position=inline-start]) .ids-checkbox label {
    display: flex;
    align-items: center;
    width: 100%;
    padding-block: var(--ids-label-padding-block);
    box-sizing: border-box;
    gap: var(--ids-space-xs);
  }
  :host([label-position=inline-start]) .ids-checkbox .label-checkbox {
    width: var(--ids-label-width);
    flex-shrink: 0;
  }
  :host([label-position=inline-start]) .ids-checkbox .checkbox-wrapper {
    position: relative;
    display: inline-flex;
  }
  :host([label-position=inline-start]) .ids-checkbox .field-container {
    flex: 1;
  }
  :host([label-position=inline-start]) .ids-checkbox .validation-message {
    width: 100%;
    margin-inline-start: calc(var(--ids-label-width) + var(--ids-space-xs));
    margin-block-start: var(--ids-space-2xs);
  }
}

:host([label-position=inline-start][horizontal-aligned]) .ids-checkbox {
  container-type: normal;
}
@media (width <= 320px) {
  :host([label-position=inline-start][horizontal-aligned]) .ids-checkbox {
    display: flex;
    flex-wrap: wrap;
    align-items: var(--ids-label-align-y, center);
  }
  :host([label-position=inline-start][horizontal-aligned]) .ids-checkbox label {
    display: flex;
    align-items: center;
    width: 100%;
    padding-block: var(--ids-label-padding-block);
    padding-inline-end: var(--ids-label-padding-inline-end);
    box-sizing: border-box;
    gap: var(--ids-space-xs);
  }
  :host([label-position=inline-start][horizontal-aligned]) .ids-checkbox .label-checkbox {
    width: var(--ids-label-width);
    flex-shrink: 0;
  }
  :host([label-position=inline-start][horizontal-aligned]) .ids-checkbox .checkbox-wrapper {
    position: relative;
    display: inline-flex;
  }
  :host([label-position=inline-start][horizontal-aligned]) .ids-checkbox .field-container {
    flex: 1;
  }
  :host([label-position=inline-start][horizontal-aligned]) .ids-checkbox .validation-message {
    width: 100%;
    margin-inline-start: calc(var(--ids-label-width) + var(--ids-space-xs));
    margin-block-start: var(--ids-space-2xs);
  }
}

:host([label-position=inline-start][label-alignment=end]) .ids-input,
:host([label-position=inline-start][label-alignment=end]) .ids-textarea {
  gap: var(--ids-label-alignment-gap);
}
:host([label-position=inline-start][label-alignment=end]) .ids-input label,
:host([label-position=inline-start][label-alignment=end]) .ids-input .ids-label-text,
:host([label-position=inline-start][label-alignment=end]) .ids-textarea label,
:host([label-position=inline-start][label-alignment=end]) .ids-textarea .ids-label-text {
  display: inline-flex;
  align-items: center;
  justify-content: flex-end;
  text-align: end;
  position: relative;
}
@media (width < 320px) {
  :host([label-position=inline-start][label-alignment=end]) .ids-input label,
  :host([label-position=inline-start][label-alignment=end]) .ids-input .ids-label-text,
  :host([label-position=inline-start][label-alignment=end]) .ids-textarea label,
  :host([label-position=inline-start][label-alignment=end]) .ids-textarea .ids-label-text {
    justify-content: flex-start;
    text-align: start;
    align-self: start;
  }
}
@container (width < 320px) {
  :host([label-position=inline-start][label-alignment=end]) .ids-input label,
  :host([label-position=inline-start][label-alignment=end]) .ids-input .ids-label-text,
  :host([label-position=inline-start][label-alignment=end]) .ids-textarea label,
  :host([label-position=inline-start][label-alignment=end]) .ids-textarea .ids-label-text {
    justify-content: flex-start;
    text-align: start;
    align-self: start;
  }
}
:host([label-position=inline-start][label-alignment=end]) .ids-input label.required::after,
:host([label-position=inline-start][label-alignment=end]) .ids-input .ids-label-text.required::after,
:host([label-position=inline-start][label-alignment=end]) .ids-textarea label.required::after,
:host([label-position=inline-start][label-alignment=end]) .ids-textarea .ids-label-text.required::after {
  margin-inline-end: 0;
  position: absolute;
  margin-top: unset;
  inset-inline-end: -5px;
  top: 7px;
}
@container (width < 320px) {
  :host([label-position=inline-start][label-alignment=end]) .ids-input label.required::after,
  :host([label-position=inline-start][label-alignment=end]) .ids-input .ids-label-text.required::after,
  :host([label-position=inline-start][label-alignment=end]) .ids-textarea label.required::after,
  :host([label-position=inline-start][label-alignment=end]) .ids-textarea .ids-label-text.required::after {
    position: initial;
    margin-top: unset;
    inset-inline-end: initial;
  }
}
@media (width < 320px) {
  :host([label-position=inline-start][label-alignment=end]) .ids-input label.required::after,
  :host([label-position=inline-start][label-alignment=end]) .ids-input .ids-label-text.required::after,
  :host([label-position=inline-start][label-alignment=end]) .ids-textarea label.required::after,
  :host([label-position=inline-start][label-alignment=end]) .ids-textarea .ids-label-text.required::after {
    position: initial;
    margin-top: unset;
    inset-inline-end: initial;
  }
}
:host([label-position=inline-start][label-alignment=end]) .field-container {
  flex: 1;
}
:host([label-position=inline-start][label-alignment=end]) .ids-input.wrapped .validation-message,
:host([label-position=inline-start][label-alignment=end]) .ids-textarea.wrapped .validation-message {
  margin-inline-start: calc(var(--ids-label-width) + 14px);
}
:host([label-position=inline-start][label-alignment=end]) .ids-checkbox label {
  text-align: end;
}
@media (width < 320px) {
  :host([label-position=inline-start][label-alignment=end]) .ids-checkbox label {
    text-align: start;
  }
}
@container (width < 320px) {
  :host([label-position=inline-start][label-alignment=end]) .ids-checkbox label {
    text-align: start;
  }
}
:host([label-position=inline-start][label-alignment=end]) .ids-checkbox label.required .label-checkbox span::after {
  margin-inline-end: 0;
  position: absolute;
  margin-top: unset;
  right: -5px;
  top: -5px;
}
@media (width > 767px) {
  :host([label-position=inline-start][label-alignment=end]) .ids-switch label {
    display: inline-flex;
    align-items: center;
    justify-content: flex-end;
    text-align: end;
  }
  @container (width < 320px) {
    :host([label-position=inline-start][label-alignment=end]) .ids-switch label {
      justify-content: flex-start;
    }
  }
}
@media (width > 767px) and (width < 320px) {
  :host([label-position=inline-start][label-alignment=end]) .ids-switch label {
    justify-content: flex-start;
  }
}
:host([label-position=inline-start][label-alignment=end]) .ids-radio-group ids-text.group-label-text {
  display: inline-flex;
  align-items: center;
  justify-content: flex-end;
}
@container (width < 320px) {
  :host([label-position=inline-start][label-alignment=end]) .ids-radio-group ids-text.group-label-text {
    justify-content: flex-start;
  }
}

:host([label-position=inline-start][label-alignment=end][label-break=shrink-value][validation-message-count]:not([error-tracker])) .ids-input,
:host([label-position=inline-start][label-alignment=end][label-break=shrink-value][validation-message-count]:not([error-tracker])) .ids-textarea {
  column-gap: var(--ids-label-alignment-gap);
}

:host([label-position=inline-start][label-break=shrink-value]:not([validation-message-count])) .ids-input,
:host([label-position=inline-start][label-break=shrink-value]:not([validation-message-count])) .ids-textarea,
:host([label-position=inline-start][label-break=shrink-value][validation-message-count][error-tracker]) .ids-input,
:host([label-position=inline-start][label-break=shrink-value][validation-message-count][error-tracker]) .ids-textarea {
  display: flex;
  flex-wrap: nowrap;
}
:host([label-position=inline-start][label-break=shrink-value]:not([validation-message-count])) .ids-input label,
:host([label-position=inline-start][label-break=shrink-value]:not([validation-message-count])) .ids-textarea label,
:host([label-position=inline-start][label-break=shrink-value][validation-message-count][error-tracker]) .ids-input label,
:host([label-position=inline-start][label-break=shrink-value][validation-message-count][error-tracker]) .ids-textarea label {
  flex-shrink: 0;
}
:host([label-position=inline-start][label-break=shrink-value]:not([validation-message-count])) .ids-input .field-container,
:host([label-position=inline-start][label-break=shrink-value]:not([validation-message-count])) .ids-textarea .field-container,
:host([label-position=inline-start][label-break=shrink-value][validation-message-count][error-tracker]) .ids-input .field-container,
:host([label-position=inline-start][label-break=shrink-value][validation-message-count][error-tracker]) .ids-textarea .field-container {
  min-width: 0;
  flex: 0 1 auto;
}
:host([label-position=inline-start][label-break=shrink-value]:not([validation-message-count])) .ids-input .validation-message,
:host([label-position=inline-start][label-break=shrink-value]:not([validation-message-count])) .ids-textarea .validation-message,
:host([label-position=inline-start][label-break=shrink-value][validation-message-count][error-tracker]) .ids-input .validation-message,
:host([label-position=inline-start][label-break=shrink-value][validation-message-count][error-tracker]) .ids-textarea .validation-message {
  width: auto;
  margin-inline-start: 0;
}

:host(.in-flex-item[label-position=inline-start]) .ids-input,
:host(.in-flex-item[label-position=inline-start]) .ids-textarea,
:host([label-position=inline-start][label-break=shrink-value][validation-message-count]:not([error-tracker])) .ids-input,
:host([label-position=inline-start][label-break=shrink-value][validation-message-count]:not([error-tracker])) .ids-textarea {
  display: grid;
  gap: 0;
  grid-template-columns: auto minmax(0, 1fr);
  column-gap: var(--ids-label-alignment-gap);
}
:host(.in-flex-item[label-position=inline-start]) .ids-input label,
:host(.in-flex-item[label-position=inline-start]) .ids-textarea label,
:host([label-position=inline-start][label-break=shrink-value][validation-message-count]:not([error-tracker])) .ids-input label,
:host([label-position=inline-start][label-break=shrink-value][validation-message-count]:not([error-tracker])) .ids-textarea label {
  grid-column: 1;
  grid-row: 1;
}
:host(.in-flex-item[label-position=inline-start]) .ids-input .field-container,
:host(.in-flex-item[label-position=inline-start]) .ids-textarea .field-container,
:host([label-position=inline-start][label-break=shrink-value][validation-message-count]:not([error-tracker])) .ids-input .field-container,
:host([label-position=inline-start][label-break=shrink-value][validation-message-count]:not([error-tracker])) .ids-textarea .field-container {
  grid-column: 2;
  grid-row: 1;
  min-width: 0;
}
:host(.in-flex-item[label-position=inline-start]) .ids-input .validation-message,
:host(.in-flex-item[label-position=inline-start]) .ids-textarea .validation-message,
:host([label-position=inline-start][label-break=shrink-value][validation-message-count]:not([error-tracker])) .ids-input .validation-message,
:host([label-position=inline-start][label-break=shrink-value][validation-message-count]:not([error-tracker])) .ids-textarea .validation-message {
  grid-column: 1/-1;
  grid-row: 2;
  width: auto;
  margin-inline-start: 0;
  margin-block-start: var(--ids-space-2xs);
}
:host(.in-flex-item[label-position=inline-start]) .ids-input.wrapped .validation-message,
:host(.in-flex-item[label-position=inline-start]) .ids-textarea.wrapped .validation-message,
:host([label-position=inline-start][label-break=shrink-value][validation-message-count]:not([error-tracker])) .ids-input.wrapped .validation-message,
:host([label-position=inline-start][label-break=shrink-value][validation-message-count]:not([error-tracker])) .ids-textarea.wrapped .validation-message {
  grid-column: 2;
  margin-inline-start: 0;
}
:host(.in-flex-item[label-position=inline-start]) .ids-input.sm, :host(.in-flex-item[label-position=inline-start]) .ids-input.mm, :host(.in-flex-item[label-position=inline-start]) .ids-input.md, :host(.in-flex-item[label-position=inline-start]) .ids-input.lg,
:host(.in-flex-item[label-position=inline-start]) .ids-textarea.sm,
:host(.in-flex-item[label-position=inline-start]) .ids-textarea.mm,
:host(.in-flex-item[label-position=inline-start]) .ids-textarea.md,
:host(.in-flex-item[label-position=inline-start]) .ids-textarea.lg,
:host([label-position=inline-start][label-break=shrink-value][validation-message-count]:not([error-tracker])) .ids-input.sm,
:host([label-position=inline-start][label-break=shrink-value][validation-message-count]:not([error-tracker])) .ids-input.mm,
:host([label-position=inline-start][label-break=shrink-value][validation-message-count]:not([error-tracker])) .ids-input.md,
:host([label-position=inline-start][label-break=shrink-value][validation-message-count]:not([error-tracker])) .ids-input.lg,
:host([label-position=inline-start][label-break=shrink-value][validation-message-count]:not([error-tracker])) .ids-textarea.sm,
:host([label-position=inline-start][label-break=shrink-value][validation-message-count]:not([error-tracker])) .ids-textarea.mm,
:host([label-position=inline-start][label-break=shrink-value][validation-message-count]:not([error-tracker])) .ids-textarea.md,
:host([label-position=inline-start][label-break=shrink-value][validation-message-count]:not([error-tracker])) .ids-textarea.lg {
  grid-template-columns: auto;
}

:host(.in-flex-item[label-position=inline-start]) .ids-input label {
  max-height: var(--ids-label-max-height-inline-start);
}
:host(.in-flex-item[label-position=inline-start]) .ids-checkbox input[type=checkbox] ~ .checkmark {
  inset-inline-end: 0;
  margin-inline-end: 0;
}
:host(.in-flex-item[label-position=inline-start]) .ids-radio-group ids-text.group-label-text {
  margin-top: 0;
}

@media (width > 320px) {
  :host([label-position=inline-start][label-break=shrink-value]) .ids-radio-group {
    display: flex;
    align-items: var(--ids-label-align-y, baseline);
  }
  :host([label-position=inline-start][label-break=shrink-value]) .ids-radio-group ids-text.group-label-text {
    width: var(--ids-label-width);
    flex-shrink: 0;
  }
  :host([label-position=inline-start][label-break=shrink-value]) .ids-radio-group slot {
    display: flex;
    flex-direction: column;
    flex-shrink: 0;
  }
}
@container (width > 320px) {
  :host([label-position=inline-start][label-break=shrink-value]) .ids-radio-group {
    display: flex;
    align-items: var(--ids-label-align-y, baseline);
  }
  :host([label-position=inline-start][label-break=shrink-value]) .ids-radio-group ids-text.group-label-text {
    width: var(--ids-label-width);
    flex-shrink: 0;
  }
  :host([label-position=inline-start][label-break=shrink-value]) .ids-radio-group slot {
    display: flex;
    flex-direction: column;
    flex-shrink: 0;
  }
}
@media (width < 320px) {
  :host([label-position=inline-start][label-break=shrink-value]) .ids-input,
  :host([label-position=inline-start][label-break=shrink-value]) .ids-textarea {
    display: block;
  }
  :host([label-position=inline-start][label-break=shrink-value]) .ids-textarea {
    gap: 0;
  }
}
@container (width < 320px) {
  :host([label-position=inline-start][label-break=shrink-value]) .ids-input,
  :host([label-position=inline-start][label-break=shrink-value]) .ids-textarea,
  :host([label-position=inline-start][label-break=shrink-value]) .ids-radio-group {
    flex-wrap: wrap;
  }
}

@media (width <= 320px) {
  :host([label-position=inline-start][label-break=shrink-value]:not([validation-message-count])) .ids-textarea {
    display: block;
    gap: 0;
  }
  :host([label-position=inline-start][label-break=shrink-value]:not([validation-message-count])) .ids-textarea label {
    min-height: auto;
    margin-bottom: var(--ids-input-margin-bottom);
  }
}

@media (width > 320px) {
  :host([label-position=inline-start][label-break=shrink-label]) .ids-radio-group {
    display: flex;
    align-items: var(--ids-label-align-y, baseline);
  }
  :host([label-position=inline-start][label-break=shrink-label]) .ids-radio-group ids-text.group-label-text {
    width: var(--ids-label-width);
    flex: 0 1 auto;
  }
  :host([label-position=inline-start][label-break=shrink-label]) .ids-radio-group slot {
    display: flex;
    flex-direction: column;
    flex-shrink: 0;
  }
}
@container (width > 320px) {
  :host([label-position=inline-start][label-break=shrink-label]) .ids-radio-group {
    display: flex;
    align-items: var(--ids-label-align-y, baseline);
  }
  :host([label-position=inline-start][label-break=shrink-label]) .ids-radio-group ids-text.group-label-text {
    width: var(--ids-label-width);
    flex: 0 1 auto;
  }
  :host([label-position=inline-start][label-break=shrink-label]) .ids-radio-group slot {
    display: flex;
    flex-direction: column;
    flex-shrink: 0;
  }
}

:host([label-position=inline-start][label-break=break]) .ids-input,
:host([label-position=inline-start][label-break=break]) .ids-textarea {
  display: flex;
  flex-direction: column;
  align-items: stretch;
}
:host([label-position=inline-start][label-break=break]) .ids-input label,
:host([label-position=inline-start][label-break=break]) .ids-textarea label {
  width: auto;
  flex-shrink: 0;
}
:host([label-position=inline-start][label-break=break]) .ids-input .field-container,
:host([label-position=inline-start][label-break=break]) .ids-textarea .field-container {
  min-width: 0;
  flex: 0 1 auto;
}
:host([label-position=inline-start][label-break=break]) .ids-input .validation-message,
:host([label-position=inline-start][label-break=break]) .ids-textarea .validation-message {
  width: auto;
  margin-inline-start: 0;
}

:host([label-position=inline-start][label-width="0px"]) .ids-label-text,
:host([label-position=inline-start][label-width="0"]) .ids-label-text {
  display: none;
}

:host([label-position=inline-start][label-alignment=end][label-wrap=ellipsis-no-stretch]) .ids-input .ids-label-text,
:host([label-position=inline-start][label-alignment=end][label-wrap=ellipsis-no-stretch]) .ids-textarea .ids-label-text {
  margin-inline-end: 5px;
}
:host([label-position=inline-start][label-alignment=end][label-wrap=ellipsis-no-stretch]) .ids-input .ids-label-text.required,
:host([label-position=inline-start][label-alignment=end][label-wrap=ellipsis-no-stretch]) .ids-textarea .ids-label-text.required {
  padding-inline-end: 0;
}
:host([label-position=inline-start][label-alignment=end][label-wrap=ellipsis-no-stretch]) .ids-input .ids-label-text.required::after,
:host([label-position=inline-start][label-alignment=end][label-wrap=ellipsis-no-stretch]) .ids-textarea .ids-label-text.required::after {
  inset-inline-end: -11px;
}
:host([label-position=inline-start][label-alignment=end][label-wrap=ellipsis-no-stretch]) .ids-input.wrapped .validation-message,
:host([label-position=inline-start][label-alignment=end][label-wrap=ellipsis-no-stretch]) .ids-textarea.wrapped .validation-message {
  margin-inline-start: calc(var(--ids-label-width) + 11px);
}

:host([label-position=inline-end][label-break=shrink-value]) .ids-input,
:host([label-position=inline-end][label-break=shrink-value]) .ids-textarea {
  display: flex;
}
:host([label-position=inline-end][label-break=shrink-value]) .ids-input label,
:host([label-position=inline-end][label-break=shrink-value]) .ids-textarea label {
  flex-shrink: 0;
  order: 2;
}
:host([label-position=inline-end][label-break=shrink-value]) .ids-input .field-container,
:host([label-position=inline-end][label-break=shrink-value]) .ids-textarea .field-container {
  min-width: 0;
  flex: 0 1 auto;
  order: 1;
}
:host([label-position=inline-end][label-break=shrink-value]) .ids-input {
  gap: var(--ids-space-2, 0.5rem);
}

@media (width > 320px) {
  :host([label-position=inline-end][label-break=shrink-label]) .ids-radio-group {
    display: flex;
    align-items: var(--ids-label-align-y, baseline);
  }
  :host([label-position=inline-end][label-break=shrink-label]) .ids-radio-group ids-text.group-label-text {
    width: var(--ids-label-width);
    justify-content: end;
    flex: 0 1 auto;
    order: 2;
  }
  :host([label-position=inline-end][label-break=shrink-label]) .ids-radio-group slot {
    display: flex;
    flex-direction: column;
    flex-shrink: 0;
    order: 1;
  }
}

:host([label-position=inline-end][label-break=break]) .ids-input,
:host([label-position=inline-end][label-break=break]) .ids-textarea {
  display: flex;
  flex-direction: column;
  align-items: stretch;
}
:host([label-position=inline-end][label-break=break]) .ids-input label,
:host([label-position=inline-end][label-break=break]) .ids-textarea label {
  width: auto;
  flex-shrink: 0;
  order: 2;
}
:host([label-position=inline-end][label-break=break]) .ids-input .field-container,
:host([label-position=inline-end][label-break=break]) .ids-textarea .field-container {
  min-width: 0;
  flex: 0 1 auto;
  order: 1;
}
:host([label-position=inline-end][label-break=break]) .ids-input .validation-message,
:host([label-position=inline-end][label-break=break]) .ids-textarea .validation-message {
  margin-inline-start: 0;
  order: 3;
}
:host([label-position=inline-end][label-break=break]) .ids-input {
  gap: var(--ids-space-2, 0.5rem);
}

:host([label-position=inline-start]) {
  --ids-label-width: var(--ids-label-width-inline-start);
}

:host([label-position=inline-start][label-wrap=ellipsis-no-stretch]) .ids-input label,
:host([label-position=inline-start][label-wrap=ellipsis-no-stretch]) .ids-textarea label,
:host([label-position=inline-start][label-wrap=wrap-no-stretch]) .ids-input label,
:host([label-position=inline-start][label-wrap=wrap-no-stretch]) .ids-textarea label {
  align-self: var(--ids-label-align-y, center);
}
:host([label-position=inline-start][label-wrap=ellipsis-no-stretch]) .ids-input .ids-label-text,
:host([label-position=inline-start][label-wrap=ellipsis-no-stretch]) .ids-textarea .ids-label-text,
:host([label-position=inline-start][label-wrap=wrap-no-stretch]) .ids-input .ids-label-text,
:host([label-position=inline-start][label-wrap=wrap-no-stretch]) .ids-textarea .ids-label-text {
  overflow: visible;
}

@media (width > 767px) {
  :host([label-position=inline-start]) .ids-textarea {
    max-width: calc(370px + var(--ids-label-width));
  }
  :host([label-position=inline-start]) .ids-textarea .textarea-field {
    width: calc(370px + var(--ids-label-width));
  }
}
@media (width > 767px) {
  :host([label-position=inline-start]) .ids-filter-field {
    display: flex;
    flex-wrap: wrap;
    align-items: var(--ids-label-align-y, baseline);
  }
  :host([label-position=inline-start]) .ids-filter-field label {
    width: var(--ids-label-width);
    padding-block: var(--ids-label-padding-block);
    padding-inline-end: var(--ids-label-padding-inline-end);
    box-sizing: border-box;
  }
  :host([label-position=inline-start]) .ids-filter-field #operator-button {
    position: relative;
    inset-inline-start: var(--ids-label-width);
  }
  :host([label-position=inline-start]) .ids-filter-field .validation-message {
    width: 100%;
    margin-block-start: var(--ids-space-2xs);
  }
}
@media (width < 767px) {
  :host([label-position=inline-start][dir=rtl]) .ids-checkbox label {
    --ids-checkbox-padding-inline-start: inherit;
  }
  :host([label-position=inline-start][dir=rtl]) .ids-checkbox .validation-message {
    margin-inline-start: initial;
  }
}

@media (min-width: 767px) {
  :host([label-position=inline-start][dir=rtl]) .ids-checkbox input[type=checkbox] ~ .checkmark {
    right: initial;
  }
  :host([label-position=inline-start][dir=rtl]) .ids-checkbox .validation-message {
    margin-block-start: 0;
  }
}
@media (width > 320px) {
  :host([label-position=inline-start]) .ids-radio-group,
  :host([label-position=inline-end]) .ids-radio-group {
    display: flex;
    align-items: var(--ids-label-align-y, flex-start);
    gap: var(--ids-space-2, 0.5rem);
  }
  :host([label-position=inline-start]) .ids-radio-group ids-text.group-label-text,
  :host([label-position=inline-end]) .ids-radio-group ids-text.group-label-text {
    min-width: var(--ids-label-width);
    margin-top: calc(var(--ids-space-xs) - 2px);
  }
  :host([label-position=inline-start]) .ids-radio-group slot,
  :host([label-position=inline-end]) .ids-radio-group slot {
    display: flex;
    flex-direction: column;
  }
  :host([label-position=inline-end]) .ids-radio-group ids-text.group-label-text {
    justify-content: end;
    order: 2;
  }
  :host([label-position=inline-end]) .ids-radio-group slot {
    order: 1;
  }
}
@media (width < 767px) {
  :host([label-position=inline-end]):not([label-break]) .ids-radio-group {
    display: flex;
    align-items: var(--ids-label-align-y, baseline);
    gap: var(--ids-space-2, 0.5rem);
    flex-direction: column;
  }
  :host([label-position=inline-end]):not([label-break]) .ids-radio-group ids-text.group-label-text {
    min-width: var(--ids-label-width);
    order: 2;
  }
  :host([label-position=inline-end]):not([label-break]) .ids-radio-group slot {
    display: flex;
    flex-direction: column;
    order: 1;
  }
}
@container (width < 767px) {
  :host([label-position=inline-end]):not([label-break]) .ids-radio-group {
    display: flex;
    align-items: var(--ids-label-align-y, baseline);
    gap: var(--ids-space-2, 0.5rem);
    flex-direction: column;
  }
  :host([label-position=inline-end]):not([label-break]) .ids-radio-group ids-text.group-label-text {
    min-width: var(--ids-label-width);
    order: 2;
  }
  :host([label-position=inline-end]):not([label-break]) .ids-radio-group slot {
    display: flex;
    flex-direction: column;
    order: 1;
  }
}

@media (width > 767px) {
  :host([label-position=inline-start]) .ids-switch {
    display: flex;
    flex-wrap: wrap;
    align-items: var(--ids-label-align-y, baseline);
  }
  :host([label-position=inline-start]) .ids-switch label {
    width: var(--ids-label-width);
    padding-block: var(--ids-label-padding-block);
    padding-inline-end: var(--ids-label-padding-inline-end);
    padding-inline-start: 0;
    box-sizing: border-box;
  }
  :host([label-position=inline-start]) .ids-switch input[type=checkbox] ~ .slider {
    left: unset;
    right: -45px;
  }
  :host([label-position=inline-start][dir=rtl]) .ids-switch input[type=checkbox] ~ .slider {
    left: -45px;
    right: initial;
  }
}
@media (width > 767px) {
  :host([label-position=inline-start]) .ids-data-label {
    display: flex;
    flex-direction: row;
    gap: 8px;
    align-items: var(--ids-label-align-y, baseline);
  }
  :host([label-position=inline-start]) .ids-data-label .label {
    width: var(--ids-label-width);
    padding-block: var(--ids-label-padding-block);
    box-sizing: border-box;
    margin-block-end: 0;
    white-space: nowrap;
  }
  :host([label-position=inline-start]) .ids-data-label .data,
  :host([label-position=inline-start]) .ids-data-label .description {
    display: flex;
    padding-block: var(--ids-label-padding-block);
  }
}
@media (max-width: 320px) {
  :host([label-position=inline-start]) .ids-input,
  :host([label-position=inline-start]) .ids-textarea,
  :host([label-position=inline-start]) .ids-filter-field {
    display: flex;
    flex-direction: column;
    align-items: unset;
  }
  :host([label-position=inline-start]) .ids-input label,
  :host([label-position=inline-start]) .ids-textarea label,
  :host([label-position=inline-start]) .ids-filter-field label {
    width: auto;
    text-align: start;
    padding-inline: 0;
  }
  :host([label-position=inline-start]) .ids-input .validation-message,
  :host([label-position=inline-start]) .ids-textarea .validation-message,
  :host([label-position=inline-start]) .ids-filter-field .validation-message {
    margin-inline-start: 0;
  }
  :host([label-position=inline-end]) .ids-input,
  :host([label-position=inline-end]) .ids-textarea,
  :host([label-position=inline-end]) .ids-filter-field {
    display: flex;
    flex-direction: column;
    align-items: unset;
    gap: var(--ids-space-2, 0.5rem);
  }
  :host([label-position=inline-end]) .ids-input label,
  :host([label-position=inline-end]) .ids-textarea label,
  :host([label-position=inline-end]) .ids-filter-field label {
    width: auto;
    text-align: start;
    padding-inline: 0;
  }
  :host([label-position=inline-end]) .ids-input .validation-message,
  :host([label-position=inline-end]) .ids-textarea .validation-message,
  :host([label-position=inline-end]) .ids-filter-field .validation-message {
    margin-inline-start: 0;
  }
}
@container (max-width: 320px) {
  :host([label-position=inline-start]) .ids-input,
  :host([label-position=inline-start]) .ids-textarea,
  :host([label-position=inline-start]) .ids-filter-field {
    display: flex;
    flex-direction: column;
    align-items: unset;
  }
  :host([label-position=inline-start]) .ids-input label,
  :host([label-position=inline-start]) .ids-textarea label,
  :host([label-position=inline-start]) .ids-filter-field label {
    width: auto;
    text-align: start;
    padding-inline: 0;
  }
  :host([label-position=inline-start]) .ids-input .validation-message,
  :host([label-position=inline-start]) .ids-textarea .validation-message,
  :host([label-position=inline-start]) .ids-filter-field .validation-message {
    margin-inline-start: 0;
  }
  :host([label-position=inline-end]) .ids-input,
  :host([label-position=inline-end]) .ids-textarea,
  :host([label-position=inline-end]) .ids-filter-field {
    display: flex;
    flex-direction: column;
    align-items: unset;
    gap: var(--ids-space-2, 0.5rem);
  }
  :host([label-position=inline-end]) .ids-input label,
  :host([label-position=inline-end]) .ids-textarea label,
  :host([label-position=inline-end]) .ids-filter-field label {
    width: auto;
    text-align: start;
    padding-inline: 0;
  }
  :host([label-position=inline-end]) .ids-input .validation-message,
  :host([label-position=inline-end]) .ids-textarea .validation-message,
  :host([label-position=inline-end]) .ids-filter-field .validation-message {
    margin-inline-start: 0;
  }
}
@media (max-width: 320px) {
  :host([label-position=inline-start][label-state=hidden]) .ids-input .ids-label-text {
    display: none;
  }
}

@container (max-width: 320px) {
  :host([label-position=inline-start][label-state=hidden]) .ids-input .ids-label-text {
    display: none;
  }
}
:host .ids-input label,
:host .ids-input .label,
:host .ids-textarea label,
:host .ids-textarea .label,
:host .ids-checkbox label,
:host .ids-checkbox .label,
:host .ids-radio label,
:host .ids-radio .label,
:host .ids-switch label,
:host .ids-switch .label,
:host .ids-data-label label,
:host .ids-data-label .label,
:host .ids-filter-field label,
:host .ids-filter-field .label {
  width: var(--ids-label-width);
}

.ids-data-label {
  display: flex;
  flex-direction: column;
  margin-block-end: var(--ids-list-view-data-label-spacing, var(--ids-space-16));
}
.ids-data-label .label {
  color: var(--ids-color-text-label);
  margin-bottom: 8px;
}
.ids-data-label .colon {
  display: none;
}
.ids-data-label .data {
  color: var(--ids-color-text-data);
}

:host([language*=fr][show-colon]) .colon {
  padding-left: 4px;
}

:host(:not([label-width])) .ids-data-label {
  --ids-label-width: auto;
}

:host([show-colon]) .ids-data-label .colon {
  display: inline;
}

:host([compact=true]) .ids-data-label {
  margin-block-end: var(--ids-space-12);
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiL2J1aWxkcy9pbmZvci1kZXNpZ24vZW50ZXJwcmlzZS13Yy9zcmMvY29tcG9uZW50cy9pZHMtZGF0YS1sYWJlbCIsInNvdXJjZXMiOlsiLi4vLi4vdGhlbWVzL21peGlucy9pZHMtbGFiZWwtcG9zaXRpb24tbWl4aW4uc2NzcyIsImlkcy1kYXRhLWxhYmVsLnNjc3MiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBS0U7QUFBQTtFQUVFO0VBQ0E7O0FBR0E7QUFBQTtFQUNFO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7O0FBSUY7QUFBQTtFQUNFO0VBQ0E7O0FBRUE7RUFKRjtBQUFBO0lBS0k7OztBQUtGO0VBREY7QUFBQTtJQUVJOzs7QUFHRjtFQUxGO0FBQUE7SUFNSTs7O0FBSUo7RUFsQ0Y7QUFBQTtJQW1DSTtJQUNBOztFQUVBO0FBQUE7SUFDRTtJQUNBO0lBQ0E7O0VBR0Y7QUFBQTtJQUNFOztFQUdGO0FBQUE7SUFDRTtJQUNBO0lBQ0E7O0VBR0Y7QUFBQTtJQUNFO0lBQ0E7SUFDQTtJQUNBOztFQUlBO0FBQUE7SUFDRTtJQUNBOzs7QUFNUjtFQUNFOztBQUdGO0VBQ0U7SUFDRTtJQUNBO0lBQ0E7O0VBR0E7SUFDRTtJQUNBO0lBQ0E7SUFDQTtJQUNBO0lBQ0E7O0VBR0Y7SUFDRTtJQUNBOztFQUdGO0lBQ0U7SUFDQTs7RUFHRjtJQUNFOztFQUdGO0lBQ0U7SUFDQTtJQUNBOzs7QUFLTjtFQUNFO0lBQ0U7SUFDQTtJQUNBOztFQUdBO0lBQ0U7SUFDQTtJQUNBO0lBQ0E7SUFDQTtJQUNBOztFQUdGO0lBQ0U7SUFDQTs7RUFHRjtJQUNFO0lBQ0E7O0VBR0Y7SUFDRTs7RUFHRjtJQUNFO0lBQ0E7SUFDQTs7OztBQVFOO0VBQ0U7O0FBRUE7RUFIRjtJQUlJO0lBQ0E7SUFDQTs7RUFFQTtJQUNFO0lBQ0E7SUFDQTtJQUNBO0lBQ0E7SUFDQTtJQUNBOztFQUdGO0lBQ0U7SUFDQTs7RUFHRjtJQUNFO0lBQ0E7O0VBR0Y7SUFDRTs7RUFHRjtJQUNFO0lBQ0E7SUFDQTs7OztBQU9OO0FBQUE7RUFFRTs7QUFFQTtBQUFBO0FBQUE7QUFBQTtFQUVFO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7O0FBRUE7RUFSRjtBQUFBO0FBQUE7QUFBQTtJQVNJO0lBQ0E7SUFDQTs7O0FBR0Y7RUFkRjtBQUFBO0FBQUE7QUFBQTtJQWVJO0lBQ0E7SUFDQTs7O0FBSUE7QUFBQTtBQUFBO0FBQUE7RUFDRTtFQUNBO0VBQ0E7RUFDQTtFQUNBOztBQUdBO0VBUkY7QUFBQTtBQUFBO0FBQUE7SUFTSTtJQUNBO0lBQ0E7OztBQUlGO0VBZkY7QUFBQTtBQUFBO0FBQUE7SUFnQkk7SUFDQTtJQUNBOzs7QUFPVjtFQUNFOztBQUdGO0FBQUE7RUFFRTs7QUFJQTtFQUNFOztBQUVBO0VBSEY7SUFJSTs7O0FBR0Y7RUFQRjtJQVFJOzs7QUFJQTtFQUNFO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7O0FBT1I7RUFFSTtJQUNFO0lBQ0E7SUFDQTtJQUNBOztFQUVBO0lBTkY7TUFPSTs7OztBQUdGO0VBVkY7SUFXSTs7O0FBUU47RUFDRTtFQUNBO0VBQ0E7O0FBSUo7RUFFSTtJQUNFOzs7O0FBT047QUFBQTtFQUVFOzs7QUFPRjtBQUFBO0FBQUE7QUFBQTtFQUVFO0VBQ0E7O0FBRUE7QUFBQTtBQUFBO0FBQUE7RUFDRTs7QUFHRjtBQUFBO0FBQUE7QUFBQTtFQUNFO0VBQ0E7O0FBSUY7QUFBQTtBQUFBO0FBQUE7RUFDRTtFQUNBOzs7QUFRSjtBQUFBO0FBQUE7QUFBQTtFQUVFO0VBQ0E7RUFDQTtFQUNBOztBQUVBO0FBQUE7QUFBQTtBQUFBO0VBQ0U7RUFDQTs7QUFHRjtBQUFBO0FBQUE7QUFBQTtFQUNFO0VBQ0E7RUFDQTs7QUFHRjtBQUFBO0FBQUE7QUFBQTtFQUNFO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7O0FBR0Y7QUFBQTtBQUFBO0FBQUE7RUFDRTtFQUNBOztBQUdGO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0VBQ0U7OztBQU1KO0VBQ0U7O0FBSUE7RUFDRTtFQUNBOztBQU1BO0VBQ0U7OztBQU9OO0VBQ0U7SUFDRTtJQUNBOztFQUVBO0lBQ0U7SUFDQTs7RUFHRjtJQUNFO0lBQ0E7SUFDQTs7O0FBS047RUFDRTtJQUNFO0lBQ0E7O0VBRUE7SUFDRTtJQUNBOztFQUdGO0lBQ0U7SUFDQTtJQUNBOzs7QUFLTjtFQUNFO0FBQUE7SUFFRTs7RUFHRjtJQUNFOzs7QUFJSjtFQUNFO0FBQUE7QUFBQTtJQUdFOzs7O0FBTUo7RUFDRTtJQUNFO0lBQ0E7O0VBRUE7SUFDRTtJQUNBOzs7O0FBT047RUFDRTtJQUNFO0lBQ0E7O0VBRUE7SUFDRTtJQUNBOztFQUdGO0lBQ0U7SUFDQTtJQUNBOzs7QUFLTDtFQUNDO0lBQ0U7SUFDQTs7RUFFQTtJQUNFO0lBQ0E7O0VBR0Y7SUFDRTtJQUNBO0lBQ0E7Ozs7QUFPTjtBQUFBO0VBRUU7RUFDQTtFQUNBOztBQUVBO0FBQUE7RUFDRTtFQUNBOztBQUdGO0FBQUE7RUFDRTtFQUNBOztBQUlGO0FBQUE7RUFDRTtFQUNBOzs7QUFRSjtBQUFBO0VBQ0U7OztBQU9BO0FBQUE7RUFDRTs7QUFFQTtBQUFBO0VBQ0U7O0FBRUE7QUFBQTtFQUNFOztBQUtOO0FBQUE7RUFDRTs7O0FBUUo7QUFBQTtFQUVFOztBQUVBO0FBQUE7RUFDRTtFQUNBOztBQUdGO0FBQUE7RUFDRTtFQUNBO0VBQ0E7O0FBSUo7RUFDRTs7O0FBS0Y7RUFDRTtJQUNFO0lBQ0E7O0VBRUE7SUFDRTtJQUNBO0lBQ0E7SUFDQTs7RUFHRjtJQUNFO0lBQ0E7SUFDQTtJQUNBOzs7O0FBT047QUFBQTtFQUVFO0VBQ0E7RUFDQTs7QUFFQTtBQUFBO0VBQ0U7RUFDQTtFQUNBOztBQUdGO0FBQUE7RUFDRTtFQUNBO0VBQ0E7O0FBSUY7QUFBQTtFQUNFO0VBQ0E7O0FBSUo7RUFDRTs7O0FBSUo7RUFDRTs7O0FBU0U7QUFBQTtBQUFBO0FBQUE7RUFDRTs7QUFHRjtBQUFBO0FBQUE7QUFBQTtFQUNFOzs7QUFNTjtFQUVJO0lBQ0U7O0VBRUE7SUFDRTs7O0FBT1I7RUFFSTtJQUNFO0lBQ0E7SUFDQTs7RUFFQTtJQUNFO0lBQ0E7SUFDQTtJQUNBOztFQUlGO0lBQ0U7SUFDQTs7RUFJRjtJQUNFO0lBQ0E7OztBQVFOO0VBRUk7SUFDRTs7RUFHRjtJQUNFOzs7O0FBTVI7RUFFSTtJQUNFOztFQUdGO0lBQ0U7OztBQU9OO0VBR0k7QUFBQTtJQUNFO0lBQ0E7SUFDQTs7RUFFQTtBQUFBO0lBQ0U7SUFDQTs7RUFHRjtBQUFBO0lBQ0U7SUFDQTs7RUFNSjtJQUNFO0lBQ0E7O0VBR0Y7SUFDRTs7O0FBS047RUFFSTtJQUNFO0lBQ0E7SUFDQTtJQUNBOztFQUVBO0lBQ0U7SUFDQTs7RUFHRjtJQUNFO0lBQ0E7SUFDQTs7O0FBT047RUFDRTtJQUNFO0lBQ0E7SUFDQTtJQUNBOztFQUVBO0lBQ0U7SUFDQTs7RUFHRjtJQUNFO0lBQ0E7SUFDQTs7OztBQU9SO0VBQ0U7SUFDRTtJQUNBO0lBQ0E7O0VBRUE7SUFDRTtJQUNBO0lBQ0E7SUFDQTtJQUNBOztFQUdGO0lBQ0U7SUFDQTs7RUFLRjtJQUNFO0lBQ0E7OztBQU1OO0VBQ0U7SUFDRTtJQUNBO0lBQ0E7SUFDQTs7RUFFQTtJQUNFO0lBQ0E7SUFDQTtJQUNBO0lBQ0E7O0VBR0Y7QUFBQTtJQUVFO0lBQ0E7OztBQU1OO0VBRUk7QUFBQTtBQUFBO0lBR0U7SUFDQTtJQUNBOztFQUVBO0FBQUE7QUFBQTtJQUNFO0lBQ0E7SUFDQTs7RUFHRjtBQUFBO0FBQUE7SUFDRTs7RUFNSjtBQUFBO0FBQUE7SUFHRTtJQUNBO0lBQ0E7SUFDQTs7RUFFQTtBQUFBO0FBQUE7SUFDRTtJQUNBO0lBQ0E7O0VBR0Y7QUFBQTtBQUFBO0lBQ0U7OztBQU1SO0VBRUk7QUFBQTtBQUFBO0lBR0U7SUFDQTtJQUNBOztFQUVBO0FBQUE7QUFBQTtJQUNFO0lBQ0E7SUFDQTs7RUFHRjtBQUFBO0FBQUE7SUFDRTs7RUFNSjtBQUFBO0FBQUE7SUFHRTtJQUNBO0lBQ0E7SUFDQTs7RUFFQTtBQUFBO0FBQUE7SUFDRTtJQUNBO0lBQ0E7O0VBR0Y7QUFBQTtBQUFBO0lBQ0U7OztBQU9OO0VBQ0U7SUFDRTs7OztBQUtOO0VBRUk7SUFDRTs7O0FBY0Y7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTtFQUVFOzs7QUM1OUJOO0VBQ0U7RUFDQTtFQUNBOztBQUVBO0VBQ0U7RUFDQTs7QUFHRjtFQUNFOztBQUdGO0VBQ0U7OztBQUtGO0VBQ0U7OztBQUlKO0VBQ0U7OztBQUlBO0VBQ0U7OztBQUtGO0VBQ0UiLCJzb3VyY2VzQ29udGVudCI6WyIvLyBMYWJlbCBwb3NpdGlvbiBzdHlsZXNcbkB1c2UgJy4uLy4uL3RoZW1lcy9taXhpbnMvaWRzLWNvcmUtbWl4aW5zJyBhcyAqO1xuXG4vLyBMZWZ0IGFsaWduZWQgYW5kIFJpZ2h0IEFsaWduZWQgTGFiZWxzXG46aG9zdChbbGFiZWwtcG9zaXRpb249J2lubGluZS1zdGFydCddKSB7XG4gIC5pZHMtaW5wdXQsXG4gIC5pZHMtdGV4dGFyZWEge1xuICAgIGRpc3BsYXk6IGZsZXg7XG4gICAgYWxpZ24taXRlbXM6IHZhcigtLWlkcy1sYWJlbC1hbGlnbi15LCBjZW50ZXIpO1xuXG4gICAgLy8gQWRqdXN0IHRoZSBsYWJlbFxuICAgIGxhYmVsIHtcbiAgICAgIHdpZHRoOiB2YXIoLS1pZHMtbGFiZWwtd2lkdGgpO1xuICAgICAgcGFkZGluZy1ibG9jazogdmFyKC0taWRzLWxhYmVsLXBhZGRpbmctYmxvY2spO1xuICAgICAgcGFkZGluZy1pbmxpbmUtZW5kOiAwO1xuICAgICAgYm94LXNpemluZzogYm9yZGVyLWJveDtcbiAgICAgIGZsZXgtc2hyaW5rOiAwO1xuICAgIH1cblxuICAgIC8vIFZhbGlkYXRpb24gb24gdGhlIGJvdHRvbVxuICAgIC52YWxpZGF0aW9uLW1lc3NhZ2Uge1xuICAgICAgd2lkdGg6IDEwMCU7XG4gICAgICBtYXJnaW4tYmxvY2stc3RhcnQ6IHZhcigtLWlkcy1zcGFjZS0yeHMpO1xuXG4gICAgICBAbWVkaWEgKG1heC13aWR0aDogJGJyZWFrcG9pbnQtbWQpIHtcbiAgICAgICAgbWFyZ2luLWlubGluZS1zdGFydDogMDtcbiAgICAgIH1cbiAgICB9XG5cbiAgICAuaWRzLWxhYmVsLXRleHQge1xuICAgICAgQG1lZGlhICh3aWR0aCA+ICRicmVha3BvaW50LXhzKSB7XG4gICAgICAgIG1hcmdpbi1pbmxpbmUtZW5kOiAwO1xuICAgICAgfVxuXG4gICAgICBAY29udGFpbmVyICh3aWR0aCA+ICRicmVha3BvaW50LXhzKSB7XG4gICAgICAgIG1hcmdpbi1pbmxpbmUtZW5kOiAwO1xuICAgICAgfVxuICAgIH1cblxuICAgIEBtZWRpYSAobWluLXdpZHRoOiAkYnJlYWtwb2ludC14cykge1xuICAgICAgZmxleC13cmFwOiB3cmFwO1xuICAgICAgZ2FwOiA4cHg7XG5cbiAgICAgIGxhYmVsIHtcbiAgICAgICAgZmxleDogMCAwIGF1dG87XG4gICAgICAgIG1hcmdpbi1ib3R0b206IHVuc2V0O1xuICAgICAgICBvcmRlcjogMTtcbiAgICAgIH1cblxuICAgICAgLmZpZWxkLWNvbnRhaW5lciB7XG4gICAgICAgIG9yZGVyOiAyO1xuICAgICAgfVxuXG4gICAgICAudGV4dGFyZWEtZmllbGQtZ3JvdXAge1xuICAgICAgICBvcmRlcjogMjtcbiAgICAgICAgZmxleDogMSAxIGF1dG87XG4gICAgICAgIG1pbi13aWR0aDogMDtcbiAgICAgIH1cblxuICAgICAgLnZhbGlkYXRpb24tbWVzc2FnZSB7XG4gICAgICAgIGZsZXg6IDEgMSAxMDAlO1xuICAgICAgICBtaW4td2lkdGg6IDEwMCU7XG4gICAgICAgIG9yZGVyOiAzO1xuICAgICAgICBtYXJnaW4tYmxvY2stc3RhcnQ6IGNhbGMoMHB4IC0gdmFyKC0taWRzLXNwYWNlLTJ4cykpO1xuICAgICAgfVxuXG4gICAgICAmLndyYXBwZWQge1xuICAgICAgICAudmFsaWRhdGlvbi1tZXNzYWdlIHtcbiAgICAgICAgICBtYXJnaW4tYmxvY2stc3RhcnQ6IGNhbGMoMHB4IC0gdmFyKC0taWRzLXNwYWNlLTJ4cykpO1xuICAgICAgICAgIG1hcmdpbi1pbmxpbmUtc3RhcnQ6IGNhbGModmFyKC0taWRzLWxhYmVsLXdpZHRoKSArIDZweCk7XG4gICAgICAgIH1cbiAgICAgIH1cbiAgICB9XG4gIH1cblxuICAuaWRzLWNoZWNrYm94IHtcbiAgICBtYXJnaW4tdG9wOiB2YXIoLS1pZHMtc3BhY2UtMDApO1xuICB9XG5cbiAgQG1lZGlhIChtaW4td2lkdGg6ICN7JGJyZWFrcG9pbnQteHN9KSB7XG4gICAgLmlkcy1jaGVja2JveCB7XG4gICAgICBkaXNwbGF5OiBmbGV4O1xuICAgICAgZmxleC13cmFwOiB3cmFwO1xuICAgICAgYWxpZ24taXRlbXM6IHZhcigtLWlkcy1sYWJlbC1hbGlnbi15LCBjZW50ZXIpO1xuXG4gICAgICAvLyBBZGp1c3QgdGhlIGxhYmVsXG4gICAgICBsYWJlbCB7XG4gICAgICAgIGRpc3BsYXk6IGZsZXg7XG4gICAgICAgIGFsaWduLWl0ZW1zOiBjZW50ZXI7XG4gICAgICAgIHdpZHRoOiAxMDAlO1xuICAgICAgICBwYWRkaW5nLWJsb2NrOiB2YXIoLS1pZHMtbGFiZWwtcGFkZGluZy1ibG9jayk7XG4gICAgICAgIGJveC1zaXppbmc6IGJvcmRlci1ib3g7XG4gICAgICAgIGdhcDogdmFyKC0taWRzLXNwYWNlLXhzKTtcbiAgICAgIH1cblxuICAgICAgLmxhYmVsLWNoZWNrYm94IHtcbiAgICAgICAgd2lkdGg6IHZhcigtLWlkcy1sYWJlbC13aWR0aCk7XG4gICAgICAgIGZsZXgtc2hyaW5rOiAwO1xuICAgICAgfVxuXG4gICAgICAuY2hlY2tib3gtd3JhcHBlciB7XG4gICAgICAgIHBvc2l0aW9uOiByZWxhdGl2ZTtcbiAgICAgICAgZGlzcGxheTogaW5saW5lLWZsZXg7XG4gICAgICB9XG5cbiAgICAgIC5maWVsZC1jb250YWluZXIge1xuICAgICAgICBmbGV4OiAxO1xuICAgICAgfVxuXG4gICAgICAudmFsaWRhdGlvbi1tZXNzYWdlIHtcbiAgICAgICAgd2lkdGg6IDEwMCU7XG4gICAgICAgIG1hcmdpbi1pbmxpbmUtc3RhcnQ6IGNhbGModmFyKC0taWRzLWxhYmVsLXdpZHRoKSArIHZhcigtLWlkcy1zcGFjZS14cykpO1xuICAgICAgICBtYXJnaW4tYmxvY2stc3RhcnQ6IHZhcigtLWlkcy1zcGFjZS0yeHMpO1xuICAgICAgfVxuICAgIH1cbiAgfVxuXG4gIEBjb250YWluZXIgKG1pbi13aWR0aDogI3skYnJlYWtwb2ludC14c30pIHtcbiAgICAuaWRzLWNoZWNrYm94IHtcbiAgICAgIGRpc3BsYXk6IGZsZXg7XG4gICAgICBmbGV4LXdyYXA6IHdyYXA7XG4gICAgICBhbGlnbi1pdGVtczogdmFyKC0taWRzLWxhYmVsLWFsaWduLXksIGNlbnRlcik7XG5cbiAgICAgIC8vIEFkanVzdCB0aGUgbGFiZWxcbiAgICAgIGxhYmVsIHtcbiAgICAgICAgZGlzcGxheTogZmxleDtcbiAgICAgICAgYWxpZ24taXRlbXM6IGNlbnRlcjtcbiAgICAgICAgd2lkdGg6IDEwMCU7XG4gICAgICAgIHBhZGRpbmctYmxvY2s6IHZhcigtLWlkcy1sYWJlbC1wYWRkaW5nLWJsb2NrKTtcbiAgICAgICAgYm94LXNpemluZzogYm9yZGVyLWJveDtcbiAgICAgICAgZ2FwOiB2YXIoLS1pZHMtc3BhY2UteHMpO1xuICAgICAgfVxuXG4gICAgICAubGFiZWwtY2hlY2tib3gge1xuICAgICAgICB3aWR0aDogdmFyKC0taWRzLWxhYmVsLXdpZHRoKTtcbiAgICAgICAgZmxleC1zaHJpbms6IDA7XG4gICAgICB9XG5cbiAgICAgIC5jaGVja2JveC13cmFwcGVyIHtcbiAgICAgICAgcG9zaXRpb246IHJlbGF0aXZlO1xuICAgICAgICBkaXNwbGF5OiBpbmxpbmUtZmxleDtcbiAgICAgIH1cblxuICAgICAgLmZpZWxkLWNvbnRhaW5lciB7XG4gICAgICAgIGZsZXg6IDE7XG4gICAgICB9XG5cbiAgICAgIC52YWxpZGF0aW9uLW1lc3NhZ2Uge1xuICAgICAgICB3aWR0aDogMTAwJTtcbiAgICAgICAgbWFyZ2luLWlubGluZS1zdGFydDogY2FsYyh2YXIoLS1pZHMtbGFiZWwtd2lkdGgpICsgdmFyKC0taWRzLXNwYWNlLXhzKSk7XG4gICAgICAgIG1hcmdpbi1ibG9jay1zdGFydDogdmFyKC0taWRzLXNwYWNlLTJ4cyk7XG4gICAgICB9XG4gICAgfVxuICB9XG59XG5cbi8vIEhvcml6b250YWwgYWxpZ25lZDogdXNlIHZpZXdwb3J0IG1lZGlhIHF1ZXJ5IGluc3RlYWQgb2YgY29udGFpbmVyIHF1ZXJ5XG46aG9zdChbbGFiZWwtcG9zaXRpb249J2lubGluZS1zdGFydCddW2hvcml6b250YWwtYWxpZ25lZF0pIHtcbiAgLmlkcy1jaGVja2JveCB7XG4gICAgY29udGFpbmVyLXR5cGU6IG5vcm1hbDtcblxuICAgIEBtZWRpYSAod2lkdGggPD0gJGJyZWFrcG9pbnQteHMpIHtcbiAgICAgIGRpc3BsYXk6IGZsZXg7XG4gICAgICBmbGV4LXdyYXA6IHdyYXA7XG4gICAgICBhbGlnbi1pdGVtczogdmFyKC0taWRzLWxhYmVsLWFsaWduLXksIGNlbnRlcik7XG5cbiAgICAgIGxhYmVsIHtcbiAgICAgICAgZGlzcGxheTogZmxleDtcbiAgICAgICAgYWxpZ24taXRlbXM6IGNlbnRlcjtcbiAgICAgICAgd2lkdGg6IDEwMCU7XG4gICAgICAgIHBhZGRpbmctYmxvY2s6IHZhcigtLWlkcy1sYWJlbC1wYWRkaW5nLWJsb2NrKTtcbiAgICAgICAgcGFkZGluZy1pbmxpbmUtZW5kOiB2YXIoLS1pZHMtbGFiZWwtcGFkZGluZy1pbmxpbmUtZW5kKTtcbiAgICAgICAgYm94LXNpemluZzogYm9yZGVyLWJveDtcbiAgICAgICAgZ2FwOiB2YXIoLS1pZHMtc3BhY2UteHMpO1xuICAgICAgfVxuXG4gICAgICAubGFiZWwtY2hlY2tib3gge1xuICAgICAgICB3aWR0aDogdmFyKC0taWRzLWxhYmVsLXdpZHRoKTtcbiAgICAgICAgZmxleC1zaHJpbms6IDA7XG4gICAgICB9XG5cbiAgICAgIC5jaGVja2JveC13cmFwcGVyIHtcbiAgICAgICAgcG9zaXRpb246IHJlbGF0aXZlO1xuICAgICAgICBkaXNwbGF5OiBpbmxpbmUtZmxleDtcbiAgICAgIH1cblxuICAgICAgLmZpZWxkLWNvbnRhaW5lciB7XG4gICAgICAgIGZsZXg6IDE7XG4gICAgICB9XG5cbiAgICAgIC52YWxpZGF0aW9uLW1lc3NhZ2Uge1xuICAgICAgICB3aWR0aDogMTAwJTtcbiAgICAgICAgbWFyZ2luLWlubGluZS1zdGFydDogY2FsYyh2YXIoLS1pZHMtbGFiZWwtd2lkdGgpICsgdmFyKC0taWRzLXNwYWNlLXhzKSk7XG4gICAgICAgIG1hcmdpbi1ibG9jay1zdGFydDogdmFyKC0taWRzLXNwYWNlLTJ4cyk7XG4gICAgICB9XG4gICAgfVxuICB9XG59XG5cbjpob3N0KFtsYWJlbC1wb3NpdGlvbj0naW5saW5lLXN0YXJ0J11bbGFiZWwtYWxpZ25tZW50PVwiZW5kXCJdKSB7XG4gIC5pZHMtaW5wdXQsXG4gIC5pZHMtdGV4dGFyZWEge1xuICAgIGdhcDogdmFyKC0taWRzLWxhYmVsLWFsaWdubWVudC1nYXApO1xuXG4gICAgbGFiZWwsXG4gICAgLmlkcy1sYWJlbC10ZXh0IHtcbiAgICAgIGRpc3BsYXk6IGlubGluZS1mbGV4O1xuICAgICAgYWxpZ24taXRlbXM6IGNlbnRlcjtcbiAgICAgIGp1c3RpZnktY29udGVudDogZmxleC1lbmQ7XG4gICAgICB0ZXh0LWFsaWduOiBlbmQ7XG4gICAgICBwb3NpdGlvbjogcmVsYXRpdmU7XG5cbiAgICAgIEBtZWRpYSAod2lkdGggPCAkYnJlYWtwb2ludC14cykge1xuICAgICAgICBqdXN0aWZ5LWNvbnRlbnQ6IGZsZXgtc3RhcnQ7XG4gICAgICAgIHRleHQtYWxpZ246IHN0YXJ0O1xuICAgICAgICBhbGlnbi1zZWxmOiBzdGFydDtcbiAgICAgIH1cblxuICAgICAgQGNvbnRhaW5lciAod2lkdGggPCAjeyRicmVha3BvaW50LXhzfSkge1xuICAgICAgICBqdXN0aWZ5LWNvbnRlbnQ6IGZsZXgtc3RhcnQ7XG4gICAgICAgIHRleHQtYWxpZ246IHN0YXJ0O1xuICAgICAgICBhbGlnbi1zZWxmOiBzdGFydDtcbiAgICAgIH1cblxuICAgICAgJi5yZXF1aXJlZCB7XG4gICAgICAgICY6OmFmdGVyIHtcbiAgICAgICAgICBtYXJnaW4taW5saW5lLWVuZDogMDtcbiAgICAgICAgICBwb3NpdGlvbjogYWJzb2x1dGU7XG4gICAgICAgICAgbWFyZ2luLXRvcDogdW5zZXQ7XG4gICAgICAgICAgaW5zZXQtaW5saW5lLWVuZDogLTVweDtcbiAgICAgICAgICB0b3A6IDdweDtcblxuICAgICAgICAgIC8vIHN0eWxlbGludC1kaXNhYmxlLW5leHQtbGluZVxuICAgICAgICAgIEBjb250YWluZXIgKHdpZHRoIDwgI3skYnJlYWtwb2ludC14c30pIHtcbiAgICAgICAgICAgIHBvc2l0aW9uOiBpbml0aWFsO1xuICAgICAgICAgICAgbWFyZ2luLXRvcDogdW5zZXQ7XG4gICAgICAgICAgICBpbnNldC1pbmxpbmUtZW5kOiBpbml0aWFsO1xuICAgICAgICAgIH1cblxuICAgICAgICAgIC8vIHN0eWxlbGludC1kaXNhYmxlLW5leHQtbGluZVxuICAgICAgICAgIEBtZWRpYSAod2lkdGggPCAkYnJlYWtwb2ludC14cykge1xuICAgICAgICAgICAgcG9zaXRpb246IGluaXRpYWw7XG4gICAgICAgICAgICBtYXJnaW4tdG9wOiB1bnNldDtcbiAgICAgICAgICAgIGluc2V0LWlubGluZS1lbmQ6IGluaXRpYWw7XG4gICAgICAgICAgfVxuICAgICAgICB9XG4gICAgICB9XG4gICAgfVxuICB9XG5cbiAgLmZpZWxkLWNvbnRhaW5lciB7XG4gICAgZmxleDogMTtcbiAgfVxuXG4gIC5pZHMtaW5wdXQud3JhcHBlZCAudmFsaWRhdGlvbi1tZXNzYWdlLFxuICAuaWRzLXRleHRhcmVhLndyYXBwZWQgLnZhbGlkYXRpb24tbWVzc2FnZSB7XG4gICAgbWFyZ2luLWlubGluZS1zdGFydDogY2FsYyh2YXIoLS1pZHMtbGFiZWwtd2lkdGgpICsgMTRweCk7XG4gIH1cblxuICAuaWRzLWNoZWNrYm94IHtcbiAgICBsYWJlbCB7XG4gICAgICB0ZXh0LWFsaWduOiBlbmQ7XG5cbiAgICAgIEBtZWRpYSAod2lkdGggPCAkYnJlYWtwb2ludC14cykge1xuICAgICAgICB0ZXh0LWFsaWduOiBzdGFydDtcbiAgICAgIH1cblxuICAgICAgQGNvbnRhaW5lciAod2lkdGggPCAjeyRicmVha3BvaW50LXhzfSkge1xuICAgICAgICB0ZXh0LWFsaWduOiBzdGFydDtcbiAgICAgIH1cblxuICAgICAgJi5yZXF1aXJlZCAubGFiZWwtY2hlY2tib3ggc3BhbiB7XG4gICAgICAgICY6OmFmdGVyIHtcbiAgICAgICAgICBtYXJnaW4taW5saW5lLWVuZDogMDtcbiAgICAgICAgICBwb3NpdGlvbjogYWJzb2x1dGU7XG4gICAgICAgICAgbWFyZ2luLXRvcDogdW5zZXQ7XG4gICAgICAgICAgcmlnaHQ6IC01cHg7XG4gICAgICAgICAgdG9wOiAtNXB4O1xuICAgICAgICB9XG4gICAgICB9XG4gICAgfVxuICB9XG5cbiAgLy8gU3dpdGNoIGxhYmVsLWFsaWdubWVudCBlbmRcbiAgQG1lZGlhICh3aWR0aCA+ICRicmVha3BvaW50LXNtKSB7XG4gICAgLmlkcy1zd2l0Y2gge1xuICAgICAgbGFiZWwge1xuICAgICAgICBkaXNwbGF5OiBpbmxpbmUtZmxleDtcbiAgICAgICAgYWxpZ24taXRlbXM6IGNlbnRlcjtcbiAgICAgICAganVzdGlmeS1jb250ZW50OiBmbGV4LWVuZDtcbiAgICAgICAgdGV4dC1hbGlnbjogZW5kO1xuXG4gICAgICAgIEBjb250YWluZXIgKHdpZHRoIDwgI3skYnJlYWtwb2ludC14c30pIHtcbiAgICAgICAgICBqdXN0aWZ5LWNvbnRlbnQ6IGZsZXgtc3RhcnQ7XG4gICAgICAgIH1cblxuICAgICAgICBAbWVkaWEgKHdpZHRoIDwgJGJyZWFrcG9pbnQteHMpIHtcbiAgICAgICAgICBqdXN0aWZ5LWNvbnRlbnQ6IGZsZXgtc3RhcnQ7XG4gICAgICAgIH1cbiAgICAgIH1cbiAgICB9XG4gIH1cblxuICAvLyBSYWRpbyBncm91cCBsYWJlbC1hbGlnbm1lbnQgZW5kXG4gIC5pZHMtcmFkaW8tZ3JvdXAge1xuICAgIGlkcy10ZXh0Lmdyb3VwLWxhYmVsLXRleHQge1xuICAgICAgZGlzcGxheTogaW5saW5lLWZsZXg7XG4gICAgICBhbGlnbi1pdGVtczogY2VudGVyO1xuICAgICAganVzdGlmeS1jb250ZW50OiBmbGV4LWVuZDtcbiAgICB9XG4gIH1cblxuICBAY29udGFpbmVyICh3aWR0aCA8ICN7JGJyZWFrcG9pbnQteHN9KSB7XG4gICAgLmlkcy1yYWRpby1ncm91cCB7XG4gICAgICBpZHMtdGV4dC5ncm91cC1sYWJlbC10ZXh0IHtcbiAgICAgICAganVzdGlmeS1jb250ZW50OiBmbGV4LXN0YXJ0O1xuICAgICAgfVxuICAgIH1cbiAgfVxufVxuXG46aG9zdChbbGFiZWwtcG9zaXRpb249J2lubGluZS1zdGFydCddW2xhYmVsLWFsaWdubWVudD1cImVuZFwiXVtsYWJlbC1icmVhaz0nc2hyaW5rLXZhbHVlJ11bdmFsaWRhdGlvbi1tZXNzYWdlLWNvdW50XTpub3QoW2Vycm9yLXRyYWNrZXJdKSkge1xuICAuaWRzLWlucHV0LFxuICAuaWRzLXRleHRhcmVhIHtcbiAgICBjb2x1bW4tZ2FwOiB2YXIoLS1pZHMtbGFiZWwtYWxpZ25tZW50LWdhcCk7XG4gIH1cbn1cblxuLy8gTGFiZWwgYnJlYWsgYmVoYXZpb3IgZm9yIGlubGluZS1zdGFydCBwb3NpdGlvblxuOmhvc3QoW2xhYmVsLXBvc2l0aW9uPSdpbmxpbmUtc3RhcnQnXVtsYWJlbC1icmVhaz0nc2hyaW5rLXZhbHVlJ106bm90KFt2YWxpZGF0aW9uLW1lc3NhZ2UtY291bnRdKSksXG46aG9zdChbbGFiZWwtcG9zaXRpb249J2lubGluZS1zdGFydCddW2xhYmVsLWJyZWFrPSdzaHJpbmstdmFsdWUnXVt2YWxpZGF0aW9uLW1lc3NhZ2UtY291bnRdW2Vycm9yLXRyYWNrZXJdKSB7XG4gIC5pZHMtaW5wdXQsXG4gIC5pZHMtdGV4dGFyZWEge1xuICAgIGRpc3BsYXk6IGZsZXg7XG4gICAgZmxleC13cmFwOiBub3dyYXA7XG5cbiAgICBsYWJlbCB7XG4gICAgICBmbGV4LXNocmluazogMDtcbiAgICB9XG5cbiAgICAuZmllbGQtY29udGFpbmVyIHtcbiAgICAgIG1pbi13aWR0aDogMDtcbiAgICAgIGZsZXg6IDAgMSBhdXRvO1xuICAgIH1cblxuICAgIC8vIEtlZXAgdmFsaWRhdGlvbiBtZXNzYWdlcyBiZWxvdyB0aGUgZmllbGRcbiAgICAudmFsaWRhdGlvbi1tZXNzYWdlIHtcbiAgICAgIHdpZHRoOiBhdXRvO1xuICAgICAgbWFyZ2luLWlubGluZS1zdGFydDogMDtcbiAgICB9XG4gIH1cbn1cblxuLy8gV2hlbiB2YWxpZGF0aW9uIGlzIHByZXNlbnQgd2l0aCBzaHJpbmstdmFsdWUsIHVzZSBncmlkIHRvIGtlZXAgZmllbGQgd2lkdGggc3RhYmxlXG46aG9zdCguaW4tZmxleC1pdGVtW2xhYmVsLXBvc2l0aW9uPSdpbmxpbmUtc3RhcnQnXSksXG46aG9zdChbbGFiZWwtcG9zaXRpb249J2lubGluZS1zdGFydCddW2xhYmVsLWJyZWFrPSdzaHJpbmstdmFsdWUnXVt2YWxpZGF0aW9uLW1lc3NhZ2UtY291bnRdOm5vdChbZXJyb3ItdHJhY2tlcl0pKSB7XG4gIC5pZHMtaW5wdXQsXG4gIC5pZHMtdGV4dGFyZWEge1xuICAgIGRpc3BsYXk6IGdyaWQ7XG4gICAgZ2FwOiAwO1xuICAgIGdyaWQtdGVtcGxhdGUtY29sdW1uczogYXV0byBtaW5tYXgoMCwgMWZyKTtcbiAgICBjb2x1bW4tZ2FwOiB2YXIoLS1pZHMtbGFiZWwtYWxpZ25tZW50LWdhcCk7XG5cbiAgICBsYWJlbCB7XG4gICAgICBncmlkLWNvbHVtbjogMTtcbiAgICAgIGdyaWQtcm93OiAxO1xuICAgIH1cblxuICAgIC5maWVsZC1jb250YWluZXIge1xuICAgICAgZ3JpZC1jb2x1bW46IDI7XG4gICAgICBncmlkLXJvdzogMTtcbiAgICAgIG1pbi13aWR0aDogMDtcbiAgICB9XG5cbiAgICAudmFsaWRhdGlvbi1tZXNzYWdlIHtcbiAgICAgIGdyaWQtY29sdW1uOiAxIC8gLTE7XG4gICAgICBncmlkLXJvdzogMjtcbiAgICAgIHdpZHRoOiBhdXRvO1xuICAgICAgbWFyZ2luLWlubGluZS1zdGFydDogMDtcbiAgICAgIG1hcmdpbi1ibG9jay1zdGFydDogdmFyKC0taWRzLXNwYWNlLTJ4cyk7XG4gICAgfVxuXG4gICAgJi53cmFwcGVkIC52YWxpZGF0aW9uLW1lc3NhZ2Uge1xuICAgICAgZ3JpZC1jb2x1bW46IDI7XG4gICAgICBtYXJnaW4taW5saW5lLXN0YXJ0OiAwO1xuICAgIH1cblxuICAgICYuc20sICYubW0sICYubWQsICYubGcge1xuICAgICAgZ3JpZC10ZW1wbGF0ZS1jb2x1bW5zOiBhdXRvO1xuICAgIH1cbiAgfVxufVxuXG46aG9zdCguaW4tZmxleC1pdGVtW2xhYmVsLXBvc2l0aW9uPSdpbmxpbmUtc3RhcnQnXSkge1xuICAuaWRzLWlucHV0IGxhYmVsIHtcbiAgICBtYXgtaGVpZ2h0OiB2YXIoLS1pZHMtbGFiZWwtbWF4LWhlaWdodC1pbmxpbmUtc3RhcnQpO1xuICB9XG5cbiAgLmlkcy1jaGVja2JveCB7XG4gICAgaW5wdXRbdHlwZT0nY2hlY2tib3gnXSB+IC5jaGVja21hcmsge1xuICAgICAgaW5zZXQtaW5saW5lLWVuZDogMDtcbiAgICAgIG1hcmdpbi1pbmxpbmUtZW5kOiAwO1xuICAgIH1cbiAgfVxuXG4gIC5pZHMtcmFkaW8tZ3JvdXAge1xuICAgIGlkcy10ZXh0IHtcbiAgICAgICYuZ3JvdXAtbGFiZWwtdGV4dCB7XG4gICAgICAgIG1hcmdpbi10b3A6IDA7XG4gICAgICB9XG4gICAgfVxuICB9XG59XG5cbjpob3N0KFtsYWJlbC1wb3NpdGlvbj0naW5saW5lLXN0YXJ0J11bbGFiZWwtYnJlYWs9J3Nocmluay12YWx1ZSddKSB7XG4gIEBtZWRpYSAod2lkdGggPiAkYnJlYWtwb2ludC14cykge1xuICAgIC5pZHMtcmFkaW8tZ3JvdXAge1xuICAgICAgZGlzcGxheTogZmxleDtcbiAgICAgIGFsaWduLWl0ZW1zOiB2YXIoLS1pZHMtbGFiZWwtYWxpZ24teSwgYmFzZWxpbmUpO1xuXG4gICAgICBpZHMtdGV4dC5ncm91cC1sYWJlbC10ZXh0IHtcbiAgICAgICAgd2lkdGg6IHZhcigtLWlkcy1sYWJlbC13aWR0aCk7XG4gICAgICAgIGZsZXgtc2hyaW5rOiAwO1xuICAgICAgfVxuXG4gICAgICBzbG90IHtcbiAgICAgICAgZGlzcGxheTogZmxleDtcbiAgICAgICAgZmxleC1kaXJlY3Rpb246IGNvbHVtbjtcbiAgICAgICAgZmxleC1zaHJpbms6IDA7XG4gICAgICB9XG4gICAgfVxuICB9XG5cbiAgQGNvbnRhaW5lciAod2lkdGggPiAjeyRicmVha3BvaW50LXhzfSkge1xuICAgIC5pZHMtcmFkaW8tZ3JvdXAge1xuICAgICAgZGlzcGxheTogZmxleDtcbiAgICAgIGFsaWduLWl0ZW1zOiB2YXIoLS1pZHMtbGFiZWwtYWxpZ24teSwgYmFzZWxpbmUpO1xuXG4gICAgICBpZHMtdGV4dC5ncm91cC1sYWJlbC10ZXh0IHtcbiAgICAgICAgd2lkdGg6IHZhcigtLWlkcy1sYWJlbC13aWR0aCk7XG4gICAgICAgIGZsZXgtc2hyaW5rOiAwO1xuICAgICAgfVxuXG4gICAgICBzbG90IHtcbiAgICAgICAgZGlzcGxheTogZmxleDtcbiAgICAgICAgZmxleC1kaXJlY3Rpb246IGNvbHVtbjtcbiAgICAgICAgZmxleC1zaHJpbms6IDA7XG4gICAgICB9XG4gICAgfVxuICB9XG5cbiAgQG1lZGlhICh3aWR0aCA8ICRicmVha3BvaW50LXhzKSB7XG4gICAgLmlkcy1pbnB1dCxcbiAgICAuaWRzLXRleHRhcmVhIHtcbiAgICAgIGRpc3BsYXk6IGJsb2NrO1xuICAgIH1cblxuICAgIC5pZHMtdGV4dGFyZWEge1xuICAgICAgZ2FwOiAwO1xuICAgIH1cbiAgfVxuXG4gIEBjb250YWluZXIgKHdpZHRoIDwgI3skYnJlYWtwb2ludC14c30pIHtcbiAgICAuaWRzLWlucHV0LFxuICAgIC5pZHMtdGV4dGFyZWEsXG4gICAgLmlkcy1yYWRpby1ncm91cCB7XG4gICAgICBmbGV4LXdyYXA6IHdyYXA7XG4gICAgfVxuICB9XG59XG5cbjpob3N0KFtsYWJlbC1wb3NpdGlvbj0naW5saW5lLXN0YXJ0J11bbGFiZWwtYnJlYWs9J3Nocmluay12YWx1ZSddOm5vdChbdmFsaWRhdGlvbi1tZXNzYWdlLWNvdW50XSkpIHtcbiAgQG1lZGlhICh3aWR0aCA8PSAkYnJlYWtwb2ludC14cykge1xuICAgIC5pZHMtdGV4dGFyZWEge1xuICAgICAgZGlzcGxheTogYmxvY2s7XG4gICAgICBnYXA6IDA7XG5cbiAgICAgIGxhYmVsIHtcbiAgICAgICAgbWluLWhlaWdodDogYXV0bztcbiAgICAgICAgbWFyZ2luLWJvdHRvbTogdmFyKC0taWRzLWlucHV0LW1hcmdpbi1ib3R0b20pO1xuICAgICAgfVxuICAgIH1cbiAgfVxufVxuXG46aG9zdChbbGFiZWwtcG9zaXRpb249J2lubGluZS1zdGFydCddW2xhYmVsLWJyZWFrPSdzaHJpbmstbGFiZWwnXSkge1xuICBAbWVkaWEgKHdpZHRoID4gJGJyZWFrcG9pbnQteHMpIHtcbiAgICAuaWRzLXJhZGlvLWdyb3VwIHtcbiAgICAgIGRpc3BsYXk6IGZsZXg7XG4gICAgICBhbGlnbi1pdGVtczogdmFyKC0taWRzLWxhYmVsLWFsaWduLXksIGJhc2VsaW5lKTtcblxuICAgICAgaWRzLXRleHQuZ3JvdXAtbGFiZWwtdGV4dCB7XG4gICAgICAgIHdpZHRoOiB2YXIoLS1pZHMtbGFiZWwtd2lkdGgpO1xuICAgICAgICBmbGV4OiAwIDEgYXV0bztcbiAgICAgIH1cblxuICAgICAgc2xvdCB7XG4gICAgICAgIGRpc3BsYXk6IGZsZXg7XG4gICAgICAgIGZsZXgtZGlyZWN0aW9uOiBjb2x1bW47XG4gICAgICAgIGZsZXgtc2hyaW5rOiAwO1xuICAgICAgfVxuICAgIH1cbiAgfVxuXG4gICBAY29udGFpbmVyICh3aWR0aCA+ICN7JGJyZWFrcG9pbnQteHN9KSB7XG4gICAgLmlkcy1yYWRpby1ncm91cCB7XG4gICAgICBkaXNwbGF5OiBmbGV4O1xuICAgICAgYWxpZ24taXRlbXM6IHZhcigtLWlkcy1sYWJlbC1hbGlnbi15LCBiYXNlbGluZSk7XG5cbiAgICAgIGlkcy10ZXh0Lmdyb3VwLWxhYmVsLXRleHQge1xuICAgICAgICB3aWR0aDogdmFyKC0taWRzLWxhYmVsLXdpZHRoKTtcbiAgICAgICAgZmxleDogMCAxIGF1dG87XG4gICAgICB9XG5cbiAgICAgIHNsb3Qge1xuICAgICAgICBkaXNwbGF5OiBmbGV4O1xuICAgICAgICBmbGV4LWRpcmVjdGlvbjogY29sdW1uO1xuICAgICAgICBmbGV4LXNocmluazogMDtcbiAgICAgIH1cbiAgICB9XG4gIH1cbn1cblxuOmhvc3QoW2xhYmVsLXBvc2l0aW9uPSdpbmxpbmUtc3RhcnQnXVtsYWJlbC1icmVhaz0nYnJlYWsnXSkge1xuICAuaWRzLWlucHV0LFxuICAuaWRzLXRleHRhcmVhIHtcbiAgICBkaXNwbGF5OiBmbGV4O1xuICAgIGZsZXgtZGlyZWN0aW9uOiBjb2x1bW47XG4gICAgYWxpZ24taXRlbXM6IHN0cmV0Y2g7XG5cbiAgICBsYWJlbCB7XG4gICAgICB3aWR0aDogYXV0bztcbiAgICAgIGZsZXgtc2hyaW5rOiAwO1xuICAgIH1cblxuICAgIC5maWVsZC1jb250YWluZXIge1xuICAgICAgbWluLXdpZHRoOiAwO1xuICAgICAgZmxleDogMCAxIGF1dG87XG4gICAgfVxuXG4gICAgLy8gS2VlcCB2YWxpZGF0aW9uIG1lc3NhZ2VzIGJlbG93IHRoZSBmaWVsZFxuICAgIC52YWxpZGF0aW9uLW1lc3NhZ2Uge1xuICAgICAgd2lkdGg6IGF1dG87XG4gICAgICBtYXJnaW4taW5saW5lLXN0YXJ0OiAwO1xuICAgIH1cbiAgfVxufVxuXG46aG9zdChbbGFiZWwtcG9zaXRpb249J2lubGluZS1zdGFydCddW2xhYmVsLXdpZHRoPVwiMHB4XCJdKSxcbjpob3N0KFtsYWJlbC1wb3NpdGlvbj0naW5saW5lLXN0YXJ0J11bbGFiZWwtd2lkdGg9XCIwXCJdKSB7XG4gIC8vIFdoZW4gYSBsYWJlbCBpcyBcImlubGluZS1zdGFydFwiIGFuZCBgbGFiZWwtd2lkdGg9XCIwcHhcImAgc2ltcGx5IGRvbid0IGRpc3BsYXkgaXRcbiAgLmlkcy1sYWJlbC10ZXh0IHtcbiAgICBkaXNwbGF5OiBub25lO1xuICB9XG59XG5cbjpob3N0KFtsYWJlbC1wb3NpdGlvbj0naW5saW5lLXN0YXJ0J11bbGFiZWwtYWxpZ25tZW50PVwiZW5kXCJdW2xhYmVsLXdyYXA9XCJlbGxpcHNpcy1uby1zdHJldGNoXCJdKSB7XG4gIC5pZHMtaW5wdXQsXG4gIC5pZHMtdGV4dGFyZWEge1xuICAgIC5pZHMtbGFiZWwtdGV4dCB7XG4gICAgICBtYXJnaW4taW5saW5lLWVuZDogNXB4O1xuXG4gICAgICAmLnJlcXVpcmVkIHtcbiAgICAgICAgcGFkZGluZy1pbmxpbmUtZW5kOiAwO1xuXG4gICAgICAgICY6OmFmdGVyIHtcbiAgICAgICAgICBpbnNldC1pbmxpbmUtZW5kOiAtMTFweDtcbiAgICAgICAgfVxuICAgICAgfVxuICAgIH1cblxuICAgICYud3JhcHBlZCAudmFsaWRhdGlvbi1tZXNzYWdlIHtcbiAgICAgIG1hcmdpbi1pbmxpbmUtc3RhcnQ6IGNhbGModmFyKC0taWRzLWxhYmVsLXdpZHRoKSArIDExcHgpO1xuICAgIH1cbiAgfVxufVxuXG5cbi8vIExhYmVsIGJyZWFrIGJlaGF2aW9yIGZvciBpbmxpbmUtZW5kIHBvc2l0aW9uXG46aG9zdChbbGFiZWwtcG9zaXRpb249J2lubGluZS1lbmQnXVtsYWJlbC1icmVhaz0nc2hyaW5rLXZhbHVlJ10pIHtcbiAgLmlkcy1pbnB1dCxcbiAgLmlkcy10ZXh0YXJlYSB7XG4gICAgZGlzcGxheTogZmxleDtcblxuICAgIGxhYmVsIHtcbiAgICAgIGZsZXgtc2hyaW5rOiAwO1xuICAgICAgb3JkZXI6IDI7XG4gICAgfVxuXG4gICAgLmZpZWxkLWNvbnRhaW5lciB7XG4gICAgICBtaW4td2lkdGg6IDA7XG4gICAgICBmbGV4OiAwIDEgYXV0bztcbiAgICAgIG9yZGVyOiAxO1xuICAgIH1cbiAgfVxuXG4gIC5pZHMtaW5wdXQge1xuICAgIGdhcDogdmFyKC0taWRzLXNwYWNlLTIsIDAuNXJlbSk7XG4gIH1cbn1cblxuOmhvc3QoW2xhYmVsLXBvc2l0aW9uPSdpbmxpbmUtZW5kJ11bbGFiZWwtYnJlYWs9J3Nocmluay1sYWJlbCddKSB7XG4gIEBtZWRpYSAod2lkdGggPiAkYnJlYWtwb2ludC14cykge1xuICAgIC5pZHMtcmFkaW8tZ3JvdXAge1xuICAgICAgZGlzcGxheTogZmxleDtcbiAgICAgIGFsaWduLWl0ZW1zOiB2YXIoLS1pZHMtbGFiZWwtYWxpZ24teSwgYmFzZWxpbmUpO1xuXG4gICAgICBpZHMtdGV4dC5ncm91cC1sYWJlbC10ZXh0IHtcbiAgICAgICAgd2lkdGg6IHZhcigtLWlkcy1sYWJlbC13aWR0aCk7XG4gICAgICAgIGp1c3RpZnktY29udGVudDogZW5kO1xuICAgICAgICBmbGV4OiAwIDEgYXV0bztcbiAgICAgICAgb3JkZXI6IDI7XG4gICAgICB9XG5cbiAgICAgIHNsb3Qge1xuICAgICAgICBkaXNwbGF5OiBmbGV4O1xuICAgICAgICBmbGV4LWRpcmVjdGlvbjogY29sdW1uO1xuICAgICAgICBmbGV4LXNocmluazogMDtcbiAgICAgICAgb3JkZXI6IDE7XG4gICAgICB9XG4gICAgfVxuICB9XG59XG5cbjpob3N0KFtsYWJlbC1wb3NpdGlvbj0naW5saW5lLWVuZCddW2xhYmVsLWJyZWFrPSdicmVhayddKSB7XG4gIC5pZHMtaW5wdXQsXG4gIC5pZHMtdGV4dGFyZWEge1xuICAgIGRpc3BsYXk6IGZsZXg7XG4gICAgZmxleC1kaXJlY3Rpb246IGNvbHVtbjtcbiAgICBhbGlnbi1pdGVtczogc3RyZXRjaDtcblxuICAgIGxhYmVsIHtcbiAgICAgIHdpZHRoOiBhdXRvO1xuICAgICAgZmxleC1zaHJpbms6IDA7XG4gICAgICBvcmRlcjogMjtcbiAgICB9XG5cbiAgICAuZmllbGQtY29udGFpbmVyIHtcbiAgICAgIG1pbi13aWR0aDogMDtcbiAgICAgIGZsZXg6IDAgMSBhdXRvO1xuICAgICAgb3JkZXI6IDE7XG4gICAgfVxuXG4gICAgLy8gS2VlcCB2YWxpZGF0aW9uIG1lc3NhZ2VzIGJlbG93IHRoZSBmaWVsZFxuICAgIC52YWxpZGF0aW9uLW1lc3NhZ2Uge1xuICAgICAgbWFyZ2luLWlubGluZS1zdGFydDogMDtcbiAgICAgIG9yZGVyOiAzO1xuICAgIH1cbiAgfVxuXG4gIC5pZHMtaW5wdXQge1xuICAgIGdhcDogdmFyKC0taWRzLXNwYWNlLTIsIDAuNXJlbSk7XG4gIH1cbn1cblxuOmhvc3QoW2xhYmVsLXBvc2l0aW9uPVwiaW5saW5lLXN0YXJ0XCJdKSB7XG4gIC0taWRzLWxhYmVsLXdpZHRoOiB2YXIoLS1pZHMtbGFiZWwtd2lkdGgtaW5saW5lLXN0YXJ0KTtcbn1cblxuLy8gV2hlbiBsYWJlbC13cmFwIGNvbnN0cmFpbnMgdGhlIGxhYmVsIHNpemUsIGVuc3VyZSBpdCBzdGF5cyB2ZXJ0aWNhbGx5IGNlbnRlcmVkXG4vLyBpbnN0ZWFkIG9mIHN0cmV0Y2hpbmcgdG8gZmlsbCB0aGUgZmxleCBjb250YWluZXIgaGVpZ2h0XG46aG9zdChbbGFiZWwtcG9zaXRpb249XCJpbmxpbmUtc3RhcnRcIl1bbGFiZWwtd3JhcD1cImVsbGlwc2lzLW5vLXN0cmV0Y2hcIl0pLFxuOmhvc3QoW2xhYmVsLXBvc2l0aW9uPVwiaW5saW5lLXN0YXJ0XCJdW2xhYmVsLXdyYXA9XCJ3cmFwLW5vLXN0cmV0Y2hcIl0pIHtcbiAgLmlkcy1pbnB1dCxcbiAgLmlkcy10ZXh0YXJlYSB7XG4gICAgbGFiZWwge1xuICAgICAgYWxpZ24tc2VsZjogdmFyKC0taWRzLWxhYmVsLWFsaWduLXksIGNlbnRlcik7XG4gICAgfVxuXG4gICAgLmlkcy1sYWJlbC10ZXh0IHtcbiAgICAgIG92ZXJmbG93OiB2aXNpYmxlO1xuICAgIH1cbiAgfVxufVxuXG4vLyBUZXh0IGFyZWFcbkBtZWRpYSAod2lkdGggPiAkYnJlYWtwb2ludC1zbSkge1xuICA6aG9zdChbbGFiZWwtcG9zaXRpb249J2lubGluZS1zdGFydCddKSB7XG4gICAgLmlkcy10ZXh0YXJlYSB7XG4gICAgICBtYXgtd2lkdGg6IGNhbGMoMzcwcHggKyB2YXIoLS1pZHMtbGFiZWwtd2lkdGgpKTtcblxuICAgICAgLnRleHRhcmVhLWZpZWxkIHtcbiAgICAgICAgd2lkdGg6IGNhbGMoMzcwcHggKyB2YXIoLS1pZHMtbGFiZWwtd2lkdGgpKTtcbiAgICAgIH1cbiAgICB9XG4gIH1cbn1cblxuLy8gRmlsdGVyIGZpZWxkXG5AbWVkaWEgKHdpZHRoID4gJGJyZWFrcG9pbnQtc20pIHtcbiAgOmhvc3QoW2xhYmVsLXBvc2l0aW9uPSdpbmxpbmUtc3RhcnQnXSkge1xuICAgIC5pZHMtZmlsdGVyLWZpZWxkIHtcbiAgICAgIGRpc3BsYXk6IGZsZXg7XG4gICAgICBmbGV4LXdyYXA6IHdyYXA7XG4gICAgICBhbGlnbi1pdGVtczogdmFyKC0taWRzLWxhYmVsLWFsaWduLXksIGJhc2VsaW5lKTtcblxuICAgICAgbGFiZWwge1xuICAgICAgICB3aWR0aDogdmFyKC0taWRzLWxhYmVsLXdpZHRoKTtcbiAgICAgICAgcGFkZGluZy1ibG9jazogdmFyKC0taWRzLWxhYmVsLXBhZGRpbmctYmxvY2spO1xuICAgICAgICBwYWRkaW5nLWlubGluZS1lbmQ6IHZhcigtLWlkcy1sYWJlbC1wYWRkaW5nLWlubGluZS1lbmQpO1xuICAgICAgICBib3gtc2l6aW5nOiBib3JkZXItYm94O1xuICAgICAgfVxuXG4gICAgICAvLyBGaWx0ZXIgZmllbGQgc3BlY2lmaWMgcnVsZXNcbiAgICAgICNvcGVyYXRvci1idXR0b24ge1xuICAgICAgICBwb3NpdGlvbjogcmVsYXRpdmU7XG4gICAgICAgIGluc2V0LWlubGluZS1zdGFydDogdmFyKC0taWRzLWxhYmVsLXdpZHRoKTtcbiAgICAgIH1cblxuICAgICAgLy8gVmFsaWRhdGlvbiBvbiB0aGUgYm90dG9tXG4gICAgICAudmFsaWRhdGlvbi1tZXNzYWdlIHtcbiAgICAgICAgd2lkdGg6IDEwMCU7XG4gICAgICAgIG1hcmdpbi1ibG9jay1zdGFydDogdmFyKC0taWRzLXNwYWNlLTJ4cyk7XG4gICAgICB9XG4gICAgfVxuICB9XG59XG5cbi8vIENoZWNrYm94ZXNcbjpob3N0KFtsYWJlbC1wb3NpdGlvbj0naW5saW5lLXN0YXJ0J11bZGlyPSdydGwnXSkge1xuICBAbWVkaWEgKHdpZHRoIDwgJGJyZWFrcG9pbnQtc20pIHtcbiAgICAuaWRzLWNoZWNrYm94IHtcbiAgICAgIGxhYmVsIHtcbiAgICAgICAgLS1pZHMtY2hlY2tib3gtcGFkZGluZy1pbmxpbmUtc3RhcnQ6IGluaGVyaXQ7XG4gICAgICB9XG5cbiAgICAgIC52YWxpZGF0aW9uLW1lc3NhZ2Uge1xuICAgICAgICBtYXJnaW4taW5saW5lLXN0YXJ0OiBpbml0aWFsO1xuICAgICAgfVxuICAgIH1cbiAgfVxufVxuXG5AbWVkaWEgKG1pbi13aWR0aDogJGJyZWFrcG9pbnQtc20pIHtcbiAgOmhvc3QoW2xhYmVsLXBvc2l0aW9uPSdpbmxpbmUtc3RhcnQnXVtkaXI9J3J0bCddKSAuaWRzLWNoZWNrYm94IHtcbiAgICBpbnB1dFt0eXBlPSdjaGVja2JveCddIH4gLmNoZWNrbWFyayB7XG4gICAgICByaWdodDogaW5pdGlhbDtcbiAgICB9XG5cbiAgICAudmFsaWRhdGlvbi1tZXNzYWdlIHtcbiAgICAgIG1hcmdpbi1ibG9jay1zdGFydDogMDtcbiAgICB9XG4gIH1cbn1cblxuXG4vLyBSYWRpbyBidXR0b25zXG5AbWVkaWEgKHdpZHRoID4gJGJyZWFrcG9pbnQteHMpIHtcbiAgOmhvc3QoW2xhYmVsLXBvc2l0aW9uPSdpbmxpbmUtc3RhcnQnXSksXG4gIDpob3N0KFtsYWJlbC1wb3NpdGlvbj0naW5saW5lLWVuZCddKSB7XG4gICAgLmlkcy1yYWRpby1ncm91cCB7XG4gICAgICBkaXNwbGF5OiBmbGV4O1xuICAgICAgYWxpZ24taXRlbXM6IHZhcigtLWlkcy1sYWJlbC1hbGlnbi15LCBmbGV4LXN0YXJ0KTtcbiAgICAgIGdhcDogdmFyKC0taWRzLXNwYWNlLTIsIDAuNXJlbSk7XG5cbiAgICAgIGlkcy10ZXh0Lmdyb3VwLWxhYmVsLXRleHQge1xuICAgICAgICBtaW4td2lkdGg6IHZhcigtLWlkcy1sYWJlbC13aWR0aCk7XG4gICAgICAgIG1hcmdpbi10b3A6IGNhbGModmFyKC0taWRzLXNwYWNlLXhzKSAtIDJweCk7XG4gICAgICB9XG5cbiAgICAgIHNsb3Qge1xuICAgICAgICBkaXNwbGF5OiBmbGV4O1xuICAgICAgICBmbGV4LWRpcmVjdGlvbjogY29sdW1uO1xuICAgICAgfVxuICAgIH1cbiAgfVxuXG4gIDpob3N0KFtsYWJlbC1wb3NpdGlvbj0naW5saW5lLWVuZCddKSAuaWRzLXJhZGlvLWdyb3VwIHtcbiAgICBpZHMtdGV4dC5ncm91cC1sYWJlbC10ZXh0IHtcbiAgICAgIGp1c3RpZnktY29udGVudDogZW5kO1xuICAgICAgb3JkZXI6IDI7XG4gICAgfVxuXG4gICAgc2xvdCB7XG4gICAgICBvcmRlcjogMTtcbiAgICB9XG4gIH1cbn1cblxuQG1lZGlhICh3aWR0aCA8ICRicmVha3BvaW50LXNtKSB7XG4gIDpob3N0KFtsYWJlbC1wb3NpdGlvbj0naW5saW5lLWVuZCddKTpub3QoW2xhYmVsLWJyZWFrXSkge1xuICAgIC5pZHMtcmFkaW8tZ3JvdXAge1xuICAgICAgZGlzcGxheTogZmxleDtcbiAgICAgIGFsaWduLWl0ZW1zOiB2YXIoLS1pZHMtbGFiZWwtYWxpZ24teSwgYmFzZWxpbmUpO1xuICAgICAgZ2FwOiB2YXIoLS1pZHMtc3BhY2UtMiwgMC41cmVtKTtcbiAgICAgIGZsZXgtZGlyZWN0aW9uOiBjb2x1bW47XG5cbiAgICAgIGlkcy10ZXh0Lmdyb3VwLWxhYmVsLXRleHQge1xuICAgICAgICBtaW4td2lkdGg6IHZhcigtLWlkcy1sYWJlbC13aWR0aCk7XG4gICAgICAgIG9yZGVyOiAyO1xuICAgICAgfVxuXG4gICAgICBzbG90IHtcbiAgICAgICAgZGlzcGxheTogZmxleDtcbiAgICAgICAgZmxleC1kaXJlY3Rpb246IGNvbHVtbjtcbiAgICAgICAgb3JkZXI6IDE7XG4gICAgICB9XG4gICAgfVxuICB9XG59XG5cbjpob3N0KFtsYWJlbC1wb3NpdGlvbj0naW5saW5lLWVuZCddKTpub3QoW2xhYmVsLWJyZWFrXSkge1xuICBAY29udGFpbmVyICh3aWR0aCA8ICN7JGJyZWFrcG9pbnQtc219KSB7XG4gICAgLmlkcy1yYWRpby1ncm91cCB7XG4gICAgICBkaXNwbGF5OiBmbGV4O1xuICAgICAgYWxpZ24taXRlbXM6IHZhcigtLWlkcy1sYWJlbC1hbGlnbi15LCBiYXNlbGluZSk7XG4gICAgICBnYXA6IHZhcigtLWlkcy1zcGFjZS0yLCAwLjVyZW0pO1xuICAgICAgZmxleC1kaXJlY3Rpb246IGNvbHVtbjtcblxuICAgICAgaWRzLXRleHQuZ3JvdXAtbGFiZWwtdGV4dCB7XG4gICAgICAgIG1pbi13aWR0aDogdmFyKC0taWRzLWxhYmVsLXdpZHRoKTtcbiAgICAgICAgb3JkZXI6IDI7XG4gICAgICB9XG5cbiAgICAgIHNsb3Qge1xuICAgICAgICBkaXNwbGF5OiBmbGV4O1xuICAgICAgICBmbGV4LWRpcmVjdGlvbjogY29sdW1uO1xuICAgICAgICBvcmRlcjogMTtcbiAgICAgIH1cbiAgICB9XG4gIH1cbn1cblxuLy8gU3dpdGNoXG5AbWVkaWEgKHdpZHRoID4gJGJyZWFrcG9pbnQtc20pIHtcbiAgOmhvc3QoW2xhYmVsLXBvc2l0aW9uPSdpbmxpbmUtc3RhcnQnXSkgLmlkcy1zd2l0Y2gge1xuICAgIGRpc3BsYXk6IGZsZXg7XG4gICAgZmxleC13cmFwOiB3cmFwO1xuICAgIGFsaWduLWl0ZW1zOiB2YXIoLS1pZHMtbGFiZWwtYWxpZ24teSwgYmFzZWxpbmUpO1xuXG4gICAgbGFiZWwge1xuICAgICAgd2lkdGg6IHZhcigtLWlkcy1sYWJlbC13aWR0aCk7XG4gICAgICBwYWRkaW5nLWJsb2NrOiB2YXIoLS1pZHMtbGFiZWwtcGFkZGluZy1ibG9jayk7XG4gICAgICBwYWRkaW5nLWlubGluZS1lbmQ6IHZhcigtLWlkcy1sYWJlbC1wYWRkaW5nLWlubGluZS1lbmQpO1xuICAgICAgcGFkZGluZy1pbmxpbmUtc3RhcnQ6IDA7XG4gICAgICBib3gtc2l6aW5nOiBib3JkZXItYm94O1xuICAgIH1cblxuICAgIGlucHV0W3R5cGU9J2NoZWNrYm94J10gfiAuc2xpZGVyIHtcbiAgICAgIGxlZnQ6IHVuc2V0O1xuICAgICAgcmlnaHQ6IC00NXB4O1xuICAgIH1cbiAgfVxuXG4gIDpob3N0KFtsYWJlbC1wb3NpdGlvbj0naW5saW5lLXN0YXJ0J11bZGlyPSdydGwnXSkgLmlkcy1zd2l0Y2gge1xuICAgIGlucHV0W3R5cGU9J2NoZWNrYm94J10gfiAuc2xpZGVyIHtcbiAgICAgIGxlZnQ6IC00NXB4O1xuICAgICAgcmlnaHQ6IGluaXRpYWw7XG4gICAgfVxuICB9XG59XG5cbi8vIERhdGEgTGFiZWxcbkBtZWRpYSAod2lkdGggPiAkYnJlYWtwb2ludC1zbSkge1xuICA6aG9zdChbbGFiZWwtcG9zaXRpb249J2lubGluZS1zdGFydCddKSAuaWRzLWRhdGEtbGFiZWwge1xuICAgIGRpc3BsYXk6IGZsZXg7XG4gICAgZmxleC1kaXJlY3Rpb246IHJvdztcbiAgICBnYXA6IDhweDtcbiAgICBhbGlnbi1pdGVtczogdmFyKC0taWRzLWxhYmVsLWFsaWduLXksIGJhc2VsaW5lKTtcblxuICAgIC5sYWJlbCB7XG4gICAgICB3aWR0aDogdmFyKC0taWRzLWxhYmVsLXdpZHRoKTtcbiAgICAgIHBhZGRpbmctYmxvY2s6IHZhcigtLWlkcy1sYWJlbC1wYWRkaW5nLWJsb2NrKTtcbiAgICAgIGJveC1zaXppbmc6IGJvcmRlci1ib3g7XG4gICAgICBtYXJnaW4tYmxvY2stZW5kOiAwO1xuICAgICAgd2hpdGUtc3BhY2U6IG5vd3JhcDtcbiAgICB9XG5cbiAgICAuZGF0YSxcbiAgICAuZGVzY3JpcHRpb24ge1xuICAgICAgZGlzcGxheTogZmxleDtcbiAgICAgIHBhZGRpbmctYmxvY2s6IHZhcigtLWlkcy1sYWJlbC1wYWRkaW5nLWJsb2NrKTtcbiAgICB9XG4gIH1cbn1cblxuLy8gUmVzcG9uc2l2ZSBiZWhhdmlvclxuQG1lZGlhIChtYXgtd2lkdGg6ICRicmVha3BvaW50LXhzKSB7XG4gIDpob3N0KFtsYWJlbC1wb3NpdGlvbj1cImlubGluZS1zdGFydFwiXSkge1xuICAgIC5pZHMtaW5wdXQsXG4gICAgLmlkcy10ZXh0YXJlYSxcbiAgICAuaWRzLWZpbHRlci1maWVsZCB7XG4gICAgICBkaXNwbGF5OiBmbGV4O1xuICAgICAgZmxleC1kaXJlY3Rpb246IGNvbHVtbjtcbiAgICAgIGFsaWduLWl0ZW1zOiB1bnNldDtcblxuICAgICAgbGFiZWwge1xuICAgICAgICB3aWR0aDogYXV0bztcbiAgICAgICAgdGV4dC1hbGlnbjogc3RhcnQ7XG4gICAgICAgIHBhZGRpbmctaW5saW5lOiAwO1xuICAgICAgfVxuXG4gICAgICAudmFsaWRhdGlvbi1tZXNzYWdlIHtcbiAgICAgICAgbWFyZ2luLWlubGluZS1zdGFydDogMDtcbiAgICAgIH1cbiAgICB9XG4gIH1cblxuICA6aG9zdChbbGFiZWwtcG9zaXRpb249XCJpbmxpbmUtZW5kXCJdKSB7XG4gICAgLmlkcy1pbnB1dCxcbiAgICAuaWRzLXRleHRhcmVhLFxuICAgIC5pZHMtZmlsdGVyLWZpZWxkIHtcbiAgICAgIGRpc3BsYXk6IGZsZXg7XG4gICAgICBmbGV4LWRpcmVjdGlvbjogY29sdW1uO1xuICAgICAgYWxpZ24taXRlbXM6IHVuc2V0O1xuICAgICAgZ2FwOiB2YXIoLS1pZHMtc3BhY2UtMiwgMC41cmVtKTtcblxuICAgICAgbGFiZWwge1xuICAgICAgICB3aWR0aDogYXV0bztcbiAgICAgICAgdGV4dC1hbGlnbjogc3RhcnQ7XG4gICAgICAgIHBhZGRpbmctaW5saW5lOiAwO1xuICAgICAgfVxuXG4gICAgICAudmFsaWRhdGlvbi1tZXNzYWdlIHtcbiAgICAgICAgbWFyZ2luLWlubGluZS1zdGFydDogMDtcbiAgICAgIH1cbiAgICB9XG4gIH1cbn1cblxuQGNvbnRhaW5lciAobWF4LXdpZHRoOiAjeyRicmVha3BvaW50LXhzfSkge1xuICA6aG9zdChbbGFiZWwtcG9zaXRpb249XCJpbmxpbmUtc3RhcnRcIl0pIHtcbiAgICAuaWRzLWlucHV0LFxuICAgIC5pZHMtdGV4dGFyZWEsXG4gICAgLmlkcy1maWx0ZXItZmllbGQge1xuICAgICAgZGlzcGxheTogZmxleDtcbiAgICAgIGZsZXgtZGlyZWN0aW9uOiBjb2x1bW47XG4gICAgICBhbGlnbi1pdGVtczogdW5zZXQ7XG5cbiAgICAgIGxhYmVsIHtcbiAgICAgICAgd2lkdGg6IGF1dG87XG4gICAgICAgIHRleHQtYWxpZ246IHN0YXJ0O1xuICAgICAgICBwYWRkaW5nLWlubGluZTogMDtcbiAgICAgIH1cblxuICAgICAgLnZhbGlkYXRpb24tbWVzc2FnZSB7XG4gICAgICAgIG1hcmdpbi1pbmxpbmUtc3RhcnQ6IDA7XG4gICAgICB9XG4gICAgfVxuICB9XG5cbiAgOmhvc3QoW2xhYmVsLXBvc2l0aW9uPVwiaW5saW5lLWVuZFwiXSkge1xuICAgIC5pZHMtaW5wdXQsXG4gICAgLmlkcy10ZXh0YXJlYSxcbiAgICAuaWRzLWZpbHRlci1maWVsZCB7XG4gICAgICBkaXNwbGF5OiBmbGV4O1xuICAgICAgZmxleC1kaXJlY3Rpb246IGNvbHVtbjtcbiAgICAgIGFsaWduLWl0ZW1zOiB1bnNldDtcbiAgICAgIGdhcDogdmFyKC0taWRzLXNwYWNlLTIsIDAuNXJlbSk7XG5cbiAgICAgIGxhYmVsIHtcbiAgICAgICAgd2lkdGg6IGF1dG87XG4gICAgICAgIHRleHQtYWxpZ246IHN0YXJ0O1xuICAgICAgICBwYWRkaW5nLWlubGluZTogMDtcbiAgICAgIH1cblxuICAgICAgLnZhbGlkYXRpb24tbWVzc2FnZSB7XG4gICAgICAgIG1hcmdpbi1pbmxpbmUtc3RhcnQ6IDA7XG4gICAgICB9XG4gICAgfVxuICB9XG59XG5cbjpob3N0KFtsYWJlbC1wb3NpdGlvbj0naW5saW5lLXN0YXJ0J11bbGFiZWwtc3RhdGU9XCJoaWRkZW5cIl0pIHtcbiAgQG1lZGlhIChtYXgtd2lkdGg6ICRicmVha3BvaW50LXhzKSB7XG4gICAgLmlkcy1pbnB1dCAuaWRzLWxhYmVsLXRleHQge1xuICAgICAgZGlzcGxheTogbm9uZTtcbiAgICB9XG4gIH1cbn1cblxuQGNvbnRhaW5lciAobWF4LXdpZHRoOiAjeyRicmVha3BvaW50LXhzfSkge1xuICA6aG9zdChbbGFiZWwtcG9zaXRpb249J2lubGluZS1zdGFydCddW2xhYmVsLXN0YXRlPVwiaGlkZGVuXCJdKSB7XG4gICAgLmlkcy1pbnB1dCAuaWRzLWxhYmVsLXRleHQge1xuICAgICAgZGlzcGxheTogbm9uZTtcbiAgICB9XG4gIH1cbn1cblxuLy8gSnVzdCB0aGUgbGFiZWwgd2lkdGhcbjpob3N0IHtcbiAgLmlkcy1pbnB1dCxcbiAgLmlkcy10ZXh0YXJlYSxcbiAgLmlkcy1jaGVja2JveCxcbiAgLmlkcy1yYWRpbyxcbiAgLmlkcy1zd2l0Y2gsXG4gIC5pZHMtZGF0YS1sYWJlbCxcbiAgLmlkcy1maWx0ZXItZmllbGQge1xuICAgIGxhYmVsLFxuICAgIC5sYWJlbCB7XG4gICAgICB3aWR0aDogdmFyKC0taWRzLWxhYmVsLXdpZHRoKTtcbiAgICB9XG4gIH1cbn1cbiIsIkB1c2UgJy4uLy4uL3RoZW1lcy9taXhpbnMvaWRzLWxhYmVsLXBvc2l0aW9uLW1peGluLnNjc3MnIGFzIGxhYmVsLXBvc2l0aW9uO1xuXG4uaWRzLWRhdGEtbGFiZWwge1xuICBkaXNwbGF5OiBmbGV4O1xuICBmbGV4LWRpcmVjdGlvbjogY29sdW1uO1xuICBtYXJnaW4tYmxvY2stZW5kOiB2YXIoLS1pZHMtbGlzdC12aWV3LWRhdGEtbGFiZWwtc3BhY2luZywgdmFyKC0taWRzLXNwYWNlLTE2KSk7XG5cbiAgLmxhYmVsIHtcbiAgICBjb2xvcjogdmFyKC0taWRzLWNvbG9yLXRleHQtbGFiZWwpO1xuICAgIG1hcmdpbi1ib3R0b206IDhweDtcbiAgfVxuXG4gIC5jb2xvbiB7XG4gICAgZGlzcGxheTogbm9uZTtcbiAgfVxuXG4gIC5kYXRhIHtcbiAgICBjb2xvcjogdmFyKC0taWRzLWNvbG9yLXRleHQtZGF0YSk7XG4gIH1cbn1cblxuOmhvc3QoW2xhbmd1YWdlKj0nZnInXVtzaG93LWNvbG9uXSkge1xuICAuY29sb24ge1xuICAgIHBhZGRpbmctbGVmdDogNHB4O1xuICB9XG59XG5cbjpob3N0KDpub3QoW2xhYmVsLXdpZHRoXSkpIC5pZHMtZGF0YS1sYWJlbCB7XG4gIC0taWRzLWxhYmVsLXdpZHRoOiBhdXRvO1xufVxuXG46aG9zdChbc2hvdy1jb2xvbl0pIC5pZHMtZGF0YS1sYWJlbCB7XG4gIC5jb2xvbiB7XG4gICAgZGlzcGxheTogaW5saW5lO1xuICB9XG59XG5cbjpob3N0KFtjb21wYWN0PSd0cnVlJ10pIHtcbiAgLmlkcy1kYXRhLWxhYmVsIHtcbiAgICBtYXJnaW4tYmxvY2stZW5kOiB2YXIoLS1pZHMtc3BhY2UtMTIpO1xuICB9XG59XG4iXX0= */`;
